import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, Injector, OnInit, ViewChild, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { IExtraActionFooterButton } from '@modeso/aumico-layout';
import {
    AnnualReportBusinessModel,
    AnnualReportMetaInformationDTO,
    AnnualReportProvider,
    AnnualReportSharesProvider,
    AnnualReportStepsHelper,
    AnnualReportTemplatesProvider,
    CashFlowStatementPrintPreviewHelper,
    DEFAULT_GERMAN_DISPLAY_OPTIONS,
    DEFAULT_SIGNATURE_OPTIONS,
    DEFAULT_STYLE_OPTIONS,
    DEFAULT_SWISS_DISPLAY_OPTIONS,
    Errors,
    FixedAssetsScheduleValidationService,
    IEqualityCheckPrintPreviewTableData,
    IItemForCalculatingRatioOption,
    INotesDetails,
    IOptions,
    IReportSection,
    ISectionData,
    MarkerClasses,
    PrintUsingPdfTronDto,
    PrintingUtil,
    SectionIds,
    onPrintAnnualReportFailed,
    onPrintAnnualReportSuccessfully,
    onSealAnnualReportFailed,
    onSealAnnualReportSuccessfully,
    onUpdateAnnualReportFailed,
    onUpdateAnnualReportSuccessfully,
    printAnnualReport,
    printAnnualReportUsingPdfTron,
} from '@modeso/aumico-lib-annualreport-fe';
import * as fromActions from '@modeso/aumico-lib-annualreport-fe/actions/annualReport.actions';
import { IReportOrderResult } from '@modeso/aumico-lib-annualreport-fe/interfaces/i-report-order.result';
import { onUnsealAnnualReportFailed, onUnsealAnnualReportSuccessfully, onUpdatePrintOptionsFailed, onUpdatePrintOptionsSuccessfully } from '@modeso/aumico-lib-annualreport-fe/actions/annualReport.actions';
import {
    AumicoCoreLayoutProvider,
    AumicoInformationPopupComponent,
    ConfigurationsProvider,
    DateLocalePipe,
    EMPTY_ARRAY_LENGTH,
    GICSCodesUtil,
    IInvitationDialogData,
    IPopupData,
    LANGUAGES,
    LOCALE_LOCALIZATION_KEYS_MAP,
    MAT_DIALOG_CUSTOM_CLASS,
    Translation,
} from '@modeso/aumico-lib-core-fe';
import { NotesNumberingHelper } from '@modeso/aumico-lib-notes-fe/helpers/notes-numbering.helper';
import {
    FX_NOTES_PRINT_ENGINE,
    IFxNotesPrintEngine,
    IFxSuperTablePrintContext,
    AumicoNotesService,
} from '@modeso/aumico-lib-notes-fe';
import { INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { AiAgentProvider, AiAgentStatus } from '@modeso/aumico-lib-ai-agents-fe';
import { AiBackendError } from '@modeso/aumico-lib-ai-agents-fe/interfaces/ai-backend-error';
import { getAuth } from '@angular/fire/auth';
import { IReportTranslateOutput, TranslationJobHelper } from './../helpers/translationJob.helper';
import { TranslationMarkingHelper } from './../helpers/translationMarking.helper';
import { TranslationEditHtml } from './../helpers/translationEditHtml.helper';
import { TranslationMarks } from './visitors/GapReportingVisitor';
import {
    AccountMappingEngine,
    IAccountMappingFormInput,
    TemplatesProvider,
    TemplatesTranslationResponse,
    TranslationResponse,
    getTemplatesTargetTranslations,
} from '@modeso/aumico-lib-templates-fe';
import { GetOrganizationDto, OrganizationProvider, OrganizationSettings } from '@modeso/aumico-lib-users-fe';
import {
    AnnualReportStep,
    IAccount,
    IAccountMappingTemplate,
    IAnnualReport,
    IAnnualReportPdfRequest,
    IAnnualReportTemplateSettings,
    IDisplayOptions,
    IFinStatements,
    INotes,
    INotesSection,
    IPrintOptions,
    ISignatureOptions,
    IStyleOptions,
    ITranslations,
    PrintLocation,
} from '@modeso/types__aumico-lib-annualreport-be';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { FinancialLineItemType } from '@modeso/types__aumico-lib-settings-be';
import { ItemType } from '@modeso/types__aumico-lib-templates-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { I18NextService } from 'angular-i18next';
import Debug from 'debug';
import fastDeepEqual from 'fast-deep-equal/es6';
import { cloneDeep, omit } from 'lodash-es';
import { Observable, Subject, combineLatest, identity, of } from 'rxjs';
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    filter,
    find,
    first,
    map,
    mergeMap,
    startWith,
    switchMap,
    take,
    tap,
    withLatestFrom,
} from 'rxjs/operators';
import { IAuditLogDTO } from '../../../../../../aumico-lib-annualreport-fe/src/lib/dtos/get-audit-log.dto';
import { AnnualReportAction } from '../../../../../../aumico-lib-annualreport-fe/src/lib/interfaces/audit-log.interface';
import { Constants } from '../../../../../../aumico-lib-core-fe/src/lib/constants/constants';
import { getCaptionString } from '../../../../../../aumico-lib-core-fe/src/lib/utils/caption-utils';
import { NotificationsSocketService } from '../../../../../../aumico-lib-core-fe/src/lib/services/notifications-socket.service';
import { NotesEmptyLinesRemovalHelper } from '../../../../../../aumico-lib-notes-fe/src/lib';
import {
    SettingsProvider,
    SettingsTranslationResponse,
    translationsActions,
} from '../../../../../../aumico-lib-settings-fe/src/lib';
import { MixpanelService } from '../../../../../../mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from '../../../../../../mixpanel/mixpanelEvents.enum';
import { environment } from '../../../../environments/environment';
import { ArFeatureRenderingMode } from '../../../_base/arFeatureRenderingMode.enum';
import { ReorderReportSectionsDialogComponent } from '../../../components/reorder-report-sections-dialog/reorder-report-sections-dialog.component';
import { EqualityChecksResult } from '../../../enums/equality-checks-results.enum';
import { PrintPreviewTargetGroup } from '../../../enums/printPreviewTargetGroup.enum';
import { IPdfTronMapper } from '../../../interfaces/pdf-tron-mapper.interface';
import { IReorderingReportData } from '../../../interfaces/reordering-report-data.interface';
import { DataState } from '../../../shared/enum/datastate.enum';
import { UserRoles } from '../../../shared/enum/userrole.enum';
import { templateConstants } from '../../../shared/template-constants';
import { AppStateDispatcher } from '../../../state/app.state.dispatcher';
import { localizationKeys } from '../../../utils/localizationKeys';
import { EqualityChecksHelper } from '../helpers/equality-checks.helper';
import { ReportSectionsHelper } from '../helpers/report-sections/report-sections-helper';
import { ExcelMapper } from '../mappers/excel.mapper';
import { FinancialStatementMapper } from '../mappers/financial-statement-mapper';
import { PdfTronGermanMapper } from '../mappers/pdf-tron-german-mapper';
import { PdfTronSwissMapper } from '../mappers/pdf-tron-swiss-mapper';
import { TranslationMapper } from '../mappers/translation.mapper';
import { ComplementaryReportPrintService } from '../services/complementary-report-print.service';
import { TocService } from '../services/toc.service';
import { LOADING_SPINNER_STYLE } from '../utils/loading-spinner-style';
import { NotesComponentsHTMLUtil } from '../utils/notes-components-html.util';
import { AnnualReportSubPage } from './../annual-report-sub-page';
import { NAVIGATION_TABS_MAP } from '../annual-report-navigation-tabs.constant';
import { NotesLiveDataHelper } from '../helpers/notes-live-data.helper';
import { AttachmentReferencesHelper } from './../helpers/attachmentReferences.helper';
import { PrintPageHelper } from './../helpers/printPage.helper';
import { AnnualReportVisitor } from './visitors/AnnualReportsVisitor';
import { PlaceholderReplacerVisitor } from './visitors/PlaceholderReplacerVisitor';
import { ReportPart, UntranslatedTexts } from './visitors/UntranslatedTexts';
import { TranslatedAnnualReport } from './visitors/classes/TranslatedAnnualReport';
import { PreviousPeriodHelper } from '../helpers/previous-period.helper';
const PRINT_PREVIEW_CLASS_NAME_SELECTOR = 'print-preview-data';
const debug = Debug('aumico:saas:AnnualReportPrintPage');
const debugLang = Debug('aumico:AnnualReportPrintPage//language');

@UntilDestroy()
@Component({
    selector: 'aumico-annual-report-printpreview-page',
    templateUrl: 'annualReportPrint.page.html',
    styleUrls: ['annualReportPrint.page.scss'],
    providers: [FixedAssetsScheduleValidationService],
})
export class AnnualReportPrintPage extends AnnualReportSubPage implements OnInit {
    private readonly firebaseAuth: Auth = inject(Auth);

    defaultPrintOptionsValue: IPrintOptions | undefined;

    showSpinner = false;

    isSaveButtonFromPopupClicked = false;
    mainTitleDefaultValue: string | undefined;
    subTitleDefaultValue: string | undefined;
    establishmentValue: string | undefined;
    equalityCheckDataCurrentYear: IEqualityCheckPrintPreviewTableData;
    equalityCheckDataPreviousYear: IEqualityCheckPrintPreviewTableData | null;

    public complementaryReportsTitles: string[] = [];

    private localeToAnnualReport = new Map<string, IAnnualReport>();
    private localeToPredifinedLables = new Map<string, Map<string, string>>();
    private localeToTranslatedFinStatement = new Map<string, IFinStatements[]>();
    /** What `resolve` inserted per language — the review marks exactly these texts. */
    private localeToTranslationMarks = new Map<string, TranslationMarks>();
    private translatedFinstatement: IFinStatements[];
    protected predifinedLables = new Map<string, string>();

    public placeholderMap = {};
    currentFinStatements: IFinStatements[];
    organizationSettings: OrganizationSettings;
    tocService: TocService;
    isSealed: boolean;
    /** REV-22548 (P1): opening and saving the notes would change what they show, so the print shows old notes. */
    isNotesOutOfDate = false;
    showUnsealReportDialog: boolean;
    latestSealingHistory: IAuditLogDTO;
    annualReportEncryptedId: string;
    private previousLocales: string[] = [];

    public get accountMappingInput(): IAccountMappingFormInput {
        return this._accountMappingInput;
    }

    public set accountMappingInput(value: IAccountMappingFormInput) {
        this.updateChangedComponents(this._accountMappingInput, value);
        this._accountMappingInput = value;
    }

    public get currentAnnualReport(): IAnnualReport | undefined {
        return this._currentAnnualReport;
    }

    public set currentAnnualReport(value: IAnnualReport) {
        this._currentAnnualReport = value;
        this.originalAnnualReport = { ...this.originalAnnualReport };
    }

    originalAnnualReport: IAnnualReport | undefined;
    isSaveRequestInProgress = false;

    annualReport$: Observable<IAnnualReport>;
    protected _accountMappingInput: IAccountMappingFormInput = {} as any;
    printOptionsDataToBeSaved: IPrintOptions | undefined;
    readonly userLocale = this.getCurrentLanguageWithFallBack();
    readonly defaultLanguage = environment.defaultLanguage;
    subtotalText = '';
    engineBalance: AccountMappingEngine;
    engineIncome: AccountMappingEngine;
    currency: string;
    currentYearIncomeDate: string;
    previousYearIncomeDate: string;
    showSealReportDialog: boolean = false;

    protected _currentAnnualReport: IAnnualReport | undefined;

    // incase of edit mode
    printOptionsData: IPrintOptions | undefined;
    balanceIncomeAttachmentReferences: Map<string, string>;

    localizationKeys = localizationKeys;
    roles = [UserRoles.SUPER_ADMIN];

    authoringCompanyName = '';
    companyName: string;
    companyCity: string;
    companyZip: string;
    displayAssetsAndLiabilitiesInSamePage: boolean | undefined;

    notesAccordions: INotesSection[] = [];

    logoPDFFileBase64: string;
    logoCompanyBase64: string;
    printingUtilInstance: PrintingUtil = null;

    isBackendReturnError = false;
    backendErrors: string;

    protected cashFlowPrintOptions$ = new Subject<IDisplayOptions>();
    protected adjustmentsAndReclassesPrintOptions$ = new Subject<IDisplayOptions>();
    protected previousYearFliIdToAccounts: Map<string, IAccount[]> = new Map<string, IAccount[]>();
    protected currentYearFliIdToAccounts: Map<string, IAccount[]> = new Map<string, IAccount[]>();
    protected fliIdToType: Map<string, FinancialLineItemType>;

    printDisplayOptions: IDisplayOptions;
    printStyleOptions: IStyleOptions;
    printSignatureOptions: ISignatureOptions;

    noPreviousData = false;
    protected noPreviousDatePlaceholder = '-';

    previousDateTitleDefaultValue: string | undefined;
    currentDateTitleDefaultValue: string | undefined;

    protected currentCashflowStatementTotal: number | undefined;
    protected previousCashflowStatementTotal: number | undefined;

    incomeItemsOptionsForCalculatingRatio: IItemForCalculatingRatioOption[] = [];
    selectedIncomeItemForCalculatingRatio: IItemForCalculatingRatioOption | undefined;

    public defaultOrderOfReportSectionsIds: string[] = [];

    public markerClasses = MarkerClasses;

    disableShowEmsToggle = true;

    protected organization: GetOrganizationDto;
    protected annualReportForAutofill: IAnnualReport | undefined;
    protected annualReportMetaInformationId: string | undefined;

    dataState: DataState = DataState.Loading;

    printStepLabel: string = Constants.ACTION_BAR.LABELS.FINISH_AND_PRINT_KEY;

    activeArNavigations: AnnualReportStep[] = [];

    annualReportTemplateSettings: IAnnualReportTemplateSettings | undefined;

    orderedSectionsTitles: string[] = [];
    notesDetails: INotesDetails[] = [];

    orderedSectionsIds: SectionIds[] = [];
    showSealHistory: boolean = false;
    sealHistory: IAuditLogDTO[] = [];

    SectionIds = SectionIds;

    override footerExtraButtonActions: IExtraActionFooterButton[];

    GICSCodesAndNames: INameId[];

    isFixedAssetsScheduleDataValid = true;

    printPreviewTargetGroup: PrintPreviewTargetGroup | undefined;

    printPreviewTargetGroupEnum = PrintPreviewTargetGroup;

    pdfTronMapper: IPdfTronMapper | undefined;

    protected attachmentReferencesHelper: AttachmentReferencesHelper;
    protected financialStatementMapper: FinancialStatementMapper;
    protected printPageHelper: PrintPageHelper;
    protected readonly fixedAssetsScheduleValidationService: FixedAssetsScheduleValidationService;
    protected dateLocalPipe: DateLocalePipe;
    protected readonly excelMapper: ExcelMapper;
    protected organizationProvider: OrganizationProvider;
    protected readonly annualReportSharesProvider: AnnualReportSharesProvider;
    protected readonly translationMapper: TranslationMapper;
    protected readonly complementaryReportPrintService: ComplementaryReportPrintService;
    protected readonly notesService: AumicoNotesService;
    protected readonly aiAgentProvider: AiAgentProvider;

    protected readonly mixpanelService: MixpanelService;
    protected matIconRegistry: MatIconRegistry;

    protected reportLocale: string;
    private printWindow: WindowProxy | undefined;
    private translatedAnnualReport: IAnnualReport;
    private translatableItems = new Map<string, Translation>();
    private untranslatedFromVisitors = new Map<string, UntranslatedTexts>();
    translationGapCount = 0;
    showTranslationButton = false;
    translationGapsByPart: { labelKey: string; count: number; texts: string[] }[] = [];
    translationExpandedPart: string | null = null;
    translationTargetLanguageKey = '';
    translationRunState: 'question' | 'running' | 'done' | 'error' = 'question';
    translationAddedCount = 0;
    private pendingDeclinedLocales = new Set<string>();
    translationRunError: AiBackendError | null = null;
    translationProgressDone: number | null = null;
    translationProgressTotal: number | null = null;
    private translationRequested = new Set<string>();
    get translationRequestedCount(): number {
        return this.translationRequested.size;
    }
    private translationRunLocale = '';
    /** The review is open: the marking is painted and the slot top right offers "save". */
    translationReviewOpen = false;
    /** The block as the super-table inserts it — see `refreshPreviewTranslations`. A stored object, not
     * a getter: every new object re-renders the notes. */
    previewTranslations: ITranslations | undefined;
    translationEditSource: string | null = null;
    translationEditValue = '';
    /** A rich-text entry is corrected in place, formatted, not as raw HTML in a textarea. */
    translationEditIsHtml = false;

    /** Filled once when the field appears: a binding would re-run the sanitizer, which drops the
     * editor's inline styles, and would overwrite what the user typed. */
    @ViewChild('translationEditRich') set translationEditRich(element: ElementRef<HTMLDivElement> | undefined) {
        const field = element?.nativeElement;
        if (field == null || field.dataset['filled'] === 'true') {
            return;
        }
        field.innerHTML = TranslationEditHtml.clean(this.translationEditValue);
        // A placeholder is one unit; typing into it would break the replacement in the print.
        field.querySelectorAll('[data-mention]').forEach((mention) => mention.setAttribute('contenteditable', 'false'));
        field.dataset['filled'] = 'true';
    }
    private translationMarkClickListener: ((event: MouseEvent) => void) | null = null;
    /** The mark being corrected: which of its source's marks it is, so the rebuilt one can be found. */
    private translationEditMark: { element: HTMLElement; occurrence: number } | null = null;
    /** Where the corrected mark stood on screen before the rebuild — restored after the next paint. */
    private translationScrollAnchor: { source: string; occurrence: number; top: number } | null = null;
    private translationReviewLocale = '';
    showTranslationGapsDialog = false;
    showTranslationManageDialog = false;
    showTranslationLegendDialog = false;
    translationNoNewGaps = false;
    showTranslationUndoDialog = false;
    private isInternalLocaleRebuild = false;
    /** The language whose block on the page holds an AI result or a correction that is not saved yet.
     * The store only ever holds what is saved, so switching away restores the block from there. */
    private unsavedTranslationLocale: string | null = null;
    /** The next store emission is this page's own sync after a save — the page already shows it, and
     * reprocessing would overwrite unsaved print options with the stored ones. */
    private skipOwnStoreSync = false;
    /** The notes template, used to tell a template text from an edited one. */
    private notesTypes: INotesTypeEntityDTO[] = [];
    printPreviewLocalesAvailable: string[] = [];
    protected activeLocale: string;

    public ArFeatureRenderingMode = ArFeatureRenderingMode;
    public complementaryReportsAtTheStart: ISectionData[] = [];
    public complementaryReportsAtTheEnd: ISectionData[] = [];
    public complementaryReportsAsAppendix: ISectionData[] = [];

    public supportOperation: boolean = false;
    public blockExport: boolean = true;

    private sealAfterSave = false;
    private unsealInProgress = false;
    // Set when seal/unseal completes so the next autofill emission (triggered by the
    // store update) is skipped. Unlike sealAfterSave/unsealInProgress, these flags are
    // reset inside the subscribe callback itself, AFTER the async operators have
    // resolved — the action listeners reset the guards synchronously, too early.
    private skipAutofilledAfterSeal = false;
    private skipAutofilledAfterUnseal = false;

    private extraPrintButton = {
        label: 'Legecy Excel Export',
        action: () => this.exportExcel(),
        icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
        styleClassName: 'support-export-button hidden',
    };
    private extraPrintButtonV2 = {
        label: 'Export PDF V2 (Async)',
        action: () => this.printUsingPdfTronV2(),
        icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
        styleClassName: 'support-export-button',
    };
    private extraWordButtonV2 = {
        label: 'Export Word V2 (Async)',
        action: () => this.exportToWordV2(),
        icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
        styleClassName: 'support-export-button',
    };
    private extraExcelButtonV2 = {
        label: 'Export Excel V2 (Async)',
        action: () => this.exportExcelV2(),
        icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
        styleClassName: 'support-export-button',
    };
    private extraExcelStructuredButtonV2 = {
        label: 'Export Excel Structured V2 (Async)',
        action: () => this.exportExcelStructuredV2(),
        icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
        styleClassName: 'support-export-button',
    };

    private profitFliErrorMessageShown = false;

    constructor(
        protected injector: Injector,
        protected override actionsListener$: ActionsSubject,
        protected override aumicoCoreLayoutProvider: AumicoCoreLayoutProvider,
        protected matDialog: MatDialog,
        protected configuration: ConfigurationsProvider,
        protected settingsProvider: SettingsProvider,
        protected templateProvider: TemplatesProvider,
        protected readonly i18next: I18NextService,
        protected readonly annualReportTemplateProvider: AnnualReportTemplatesProvider,
        protected readonly annualReportProvider: AnnualReportProvider,
        protected readonly notesEmptyLinesRemovalHelper: NotesEmptyLinesRemovalHelper,
        protected readonly notesNumberingHelper: NotesNumberingHelper,

        protected readonly dateLocalePipe: DateLocalePipe,
        protected appStateDispatcher: AppStateDispatcher,
        protected readonly notificationsSocketService: NotificationsSocketService,
    ) {
        super(injector, actionsListener$, aumicoCoreLayoutProvider, matDialog);
        this.attachmentReferencesHelper = injector.get(AttachmentReferencesHelper);
        this.financialStatementMapper = injector.get(FinancialStatementMapper);
        this.printPageHelper = injector.get(PrintPageHelper);
        this.fixedAssetsScheduleValidationService = injector.get(FixedAssetsScheduleValidationService);
        this.dateLocalPipe = injector.get(DateLocalePipe);
        this.excelMapper = injector.get(ExcelMapper);
        this.organizationProvider = injector.get(OrganizationProvider);
        this.annualReportSharesProvider = injector.get(AnnualReportSharesProvider);
        this.translationMapper = injector.get(TranslationMapper);
        this.complementaryReportPrintService = injector.get(ComplementaryReportPrintService);
        this.notesService = injector.get(AumicoNotesService);
        this.aiAgentProvider = injector.get(AiAgentProvider);
        this.mixpanelService = injector.get(MixpanelService);
        this.matIconRegistry = injector.get(MatIconRegistry);
        this.tocService = injector.get(TocService);
        this.currentAnnualReportStep = AnnualReportStep.PRINT;

        this.initializeEqualityCheckData();
        // REV-20899: Print Preview must show values with reclassifications applied.
        this.annualReport$ = this.providerOfAnnualReports.getActiveAnnualReportWithReclasses$();
        this.disableProceedButton = false;
        this.footerExtraButtonActions = [
            this.extraPrintButtonV2,
            this.extraWordButtonV2,
            this.extraExcelButtonV2,
            this.extraExcelStructuredButtonV2
        ];

        this.addSvgIcon('document-information');

        this.GICSCodesAndNames = GICSCodesUtil.getAllGICSCodesAndSubindustryNames();

        this.organizationProvider.dispatchGetOrganizationSettings();
        this.organizationProvider
            .getOrganizationSettings()
            .pipe(
                filter((organizationSettings: OrganizationSettings) => organizationSettings != null),
                untilDestroyed(this),
            )
            .subscribe((organizationSettings: OrganizationSettings) => {
                this.organizationSettings = organizationSettings;
            });

        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                find((authoringCompany: GetOrganizationDto) => authoringCompany != null),
                untilDestroyed(this),
            )
            .subscribe((authoringCompany) => {
                this.authoringCompanyName = authoringCompany.name;
                this.organization = cloneDeep<GetOrganizationDto>(authoringCompany);
                this.logoPDFFileBase64 = authoringCompany.logo ? authoringCompany.logo.data : null;

                debug(this.authoringCompanyName);

                if (
                    this.currentAnnualReport != null &&
                    this.printOptionsDataToBeSaved != null &&
                    this.pdfTronMapper != null
                ) {
                    this.handlePrintPreview();
                }
            });
        this.organizationProvider
            .getLicenceStatus$()
            .pipe(untilDestroyed(this))
            .subscribe((value) => {
                if (value == null) return;
                const availableLicences = value.available;
                if (availableLicences === -1) {
                    this.blockExport = true;
                } else {
                    this.blockExport = false;
                }
                this.updateFooterButtons();
            });
    }

    /** REV-22548 (P1): warn only when the saved notes would actually change, never on a version number alone. */
    private updateNotesOutOfDate(annualReport: IAnnualReport, finStatements: IFinStatements[]): void {
        // The check is a hint, never a gate: if it fails, the print stays usable and shows no warning.
        try {
            this.isNotesOutOfDate = NotesLiveDataHelper.isSavedNotesOutOfDate(
                annualReport,
                finStatements,
                this.i18next.t('aumico_annual_report_fx_notes_reserve_label') as string,
            );
        } catch (error) {
            console.error('Error in updateNotesOutOfDate:', error);
            this.isNotesOutOfDate = false;
        }
    }

    onOpenNotesButtonClick(): void {
        this.router.navigate(['..', NAVIGATION_TABS_MAP.get(AnnualReportStep.NOTES).routerLink], {
            relativeTo: this.activatedRoute,
        });
    }

    override ngOnInit() {
        this.mixpanelService.time_event(MIXPANEL_EVENTS.FINISH_AND_PRINT_TIME_SPENT_TILL_COMPLETION);

        super.ngOnInit();

        this.dataState = DataState.Loading;

        this.listenToTranslationRun();

        this.loadNotesTemplateTypes();

        this.providerOfAnnualReports
            .getActiveAnnualReportEncryptedId$()
            .pipe(
                find((activeAnnualReportEncryptedId) => activeAnnualReportEncryptedId != null),
                untilDestroyed(this),
            )
            .subscribe((activeAnnualReportEncryptedId) => {
                this.providerOfAnnualReports.dispatchActiveAnnualReport(activeAnnualReportEncryptedId);
            });

        this.providerOfAnnualReports
            .getActiveMetaInformation$()
            .pipe(
                filter((metaInfo) => metaInfo != null),
                debounceTime(1000),
                untilDestroyed(this),
            )
            .subscribe((metaInfo) => {
                this.annualReportEncryptedId = metaInfo.annualReportEncryptedId;
                this.isSealed = metaInfo.isSealed;
                if (this.isSealed) {
                    this.latestSealingHistory = {
                        action: AnnualReportAction.SEAL,
                        userName: this.currentActiveUser?.displayName,
                        createdAt: new Date(),
                    };
                    this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);
                } else {
                    this.setAnnualReportStep();
                }
                this.annualReportProvider.dispatchGetReportSealHistory(this.annualReportEncryptedId);
            });

        this.cashFlowPrintOptions$
            .pipe(
                distinctUntilChanged((previous, current) =>
                    this.printPageHelper.isCashFlowPrintOptionsNotChanged(previous, current),
                ),
                untilDestroyed(this),
            )
            .subscribe(() => this.checkCashFlowWithPrintOptionsChanges());
        this.annualReportProvider
            .getPlaceholdersValues$()
            .pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.placeholderMap = value;
                if (this.pdfTronMapper != null && this.printOptionsDataToBeSaved != null) {
                    this.getPdfTronDto();
                }
            });
        this.adjustmentsAndReclassesPrintOptions$
            .pipe(
                distinctUntilChanged(
                    (previousDisplayPrintOptions: IDisplayOptions, currentDisplayPrintOptions: IDisplayOptions) =>
                        !currentDisplayPrintOptions.showRatios &&
                        this.printPageHelper.isAdjustmentsOrReclassesPrintOptionsNotChanged(
                            previousDisplayPrintOptions,
                            currentDisplayPrintOptions,
                        ),
                ),
                untilDestroyed(this),
            )
            .subscribe(() => this.prepareIncomeItemsOptionsForCalculatingRatio());

        this.getAttachmentReferences();

        const settingsTranslations$ = this.actionsListener$.pipe(
            ofType(translationsActions.onGetSettingsTargetTranslationsSuccess),
            map((action) => action.payload),
        );

        const templatesTranslations$ = this.actionsListener$.pipe(
            ofType(getTemplatesTargetTranslations.success),
            map((action) => action.payload),
        );
        const translationRequests$ = combineLatest([settingsTranslations$, templatesTranslations$]).pipe(
            filter(([templates, settings]) => templates != null || settings != null),
            first(),
        );

        this.annualReportProvider
            .getReportSealHistory$()
            .pipe(
                filter((sealHistory) => sealHistory != null),
                untilDestroyed(this),
            )
            .subscribe((sealHistory: IAuditLogDTO[]) => {
                this.sealHistory = sealHistory;
                this.latestSealingHistory = sealHistory[0];
            });

        this.annualReport$
            .pipe(
                filter(() => {
                    if (this.skipOwnStoreSync) {
                        this.skipOwnStoreSync = false;

                        return false;
                    }

                    return true;
                }),
                // REV-20899: print pipeline reads reclass-applied fin statements.
                withLatestFrom(this.annualReportProvider.getActiveFinStatementsWithReclasses$()),

                map(([activeAnnualReport, finStatements]: [IAnnualReport, IFinStatements[]]) => {
                    if (
                        activeAnnualReport != null &&
                        activeAnnualReport.generalInformation != null &&
                        finStatements.length >= templateConstants.financialStatementMinimumLength &&
                        finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template != null &&
                        finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template != null
                    ) {
                        return [activeAnnualReport, finStatements];
                    } else {
                        this.dataState = DataState.Error;

                        return [null, finStatements];
                    }
                }),

                filter((activeAnnualReport) => activeAnnualReport[0] != null),
                tap(([activeAnnualReport, finStatements]: [IAnnualReport, IFinStatements[]]) => {
                    debug('Active annual report and financial statements received in print page:', activeAnnualReport);
                    this.currentAnnualReport = activeAnnualReport;
                    this.setAnnualReportStep();

                    this.isSealed = activeAnnualReport.isSealed;
                    this.updateNotesOutOfDate(activeAnnualReport, finStatements);

                    if (this.isSealed) {
                        this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);
                    }

                    // Skip re-processing data when saving before seal to prevent the UI
                    // from being overwritten with store data that went through a backend round-trip.
                    if (!this.sealAfterSave && !this.unsealInProgress) {
                        this.updateAnnualReportData(activeAnnualReport, finStatements);
                    }

                    this.reportLocale = activeAnnualReport.locale.toLowerCase();
                }),
                mergeMap(([activeAnnualReport, finStatements]) => {
                    if (activeAnnualReport.annualReportTemplate != undefined) {
                        return of(activeAnnualReport.annualReportTemplate.locales);
                    }

                    // if the ar template is undefined then we want to show only the report locale
                    // and de - ch and en - us in the print
                    const defaultLocales = [LANGUAGES.ENGLISH, LANGUAGES.SWISS_GERMAN];
                    const localesToShow = [this.reportLocale.toLowerCase()];

                    defaultLocales.forEach((locale) => {
                        if (!localesToShow.includes(locale)) {
                            localesToShow.push(locale);
                        }
                    });
                    return of(localesToShow);
                }),

                filter((locales) => locales != null && locales.length !== EMPTY_ARRAY_LENGTH),
                // filtering out locales that still have unfinished localizations and translations
                map((locales) =>
                    locales.filter(
                        (locale) => locale.toLocaleLowerCase() !== LANGUAGES.SWISS_ITALIAN.toLocaleLowerCase(),
                    ),
                ),
                // Create a separate stream for locale changes to avoid blocking the main flow
                tap((locales) => {
                    // Manual comparison with stored previous value
                    const localesChanged =
                        this.previousLocales.length !== locales.length ||
                        !this.previousLocales.every((locale, index) => locale === locales[index]);

                    debugLang('Distinct locales check:', this.previousLocales, locales, 'changed:', localesChanged);

                    if (localesChanged) {
                        const reportLocaleIndex = locales.findIndex(
                            (locale) => locale.toLowerCase() === this.reportLocale,
                        );
                        const updatedLocales = this.setReportLocaleIfNotExist(locales, reportLocaleIndex);
                        this.printPreviewLocalesAvailable = [...updatedLocales];
                        this.dispatchGetTranslations();
                        debugLang('Print preview locales available:', 'dispatchGetTranslations');

                        // Store current locales for next comparison
                        this.previousLocales = [...locales];
                    }
                }),
                mergeMap(() => translationRequests$.pipe(startWith([]))),
                tap((translationResponse) => {
                    if (translationResponse.length === 0) return;
                    const [settingsResponse, templateResponse] = translationResponse;
                    this.setSettingsTranslationsItemsInMap(settingsResponse);

                    this.setTemplateTranslations(templateResponse);
                    this.dataState = DataState.Success;
                }),
                filter((translationResponse) => translationResponse?.length),

                switchMap(() => this.providerOfAnnualReports.getAnnualReportForBalanceAutoFill$()),
                filter((autofillAnnualReport: IAnnualReport) => autofillAnnualReport != null),

                untilDestroyed(this),
            )
            .subscribe((autofillAnnualReport: IAnnualReport) => {
                this.annualReportForAutofill = autofillAnnualReport;
                // Skip re-processing data after seal or unseal to prevent the UI from
                // being overwritten with store data that went through a backend round-trip.
                // sealAfterSave and unsealInProgress are reset synchronously by their
                // action listeners before this async callback fires, so the sticky
                // skipAfter* flags are consumed (reset) here instead.
                if (!this.sealAfterSave && !this.skipAutofilledAfterSeal && !this.skipAutofilledAfterUnseal && !this.unsealInProgress) {
                    this.handleAutofilledAnnualReport(autofillAnnualReport);
                }
                this.skipAutofilledAfterSeal = false;
                this.skipAutofilledAfterUnseal = false;
                this.handlePrintPreview();
            });

        this.actionsListener$
            .pipe(ofType(onUpdateAnnualReportSuccessfully, onUpdatePrintOptionsSuccessfully), untilDestroyed(this))
            .subscribe(() => this.onSaveSuccessfully());
        this.actionsListener$
            .pipe(ofType(onUpdateAnnualReportFailed, onUpdatePrintOptionsFailed), untilDestroyed(this))
            .subscribe(() => this.onSaveFailed());

        this.actionsListener$
            .pipe(ofType(onSealAnnualReportSuccessfully), untilDestroyed(this))
            .subscribe(() => {
                this.currentAnnualReport.isSealed = true;
                if (this.translatedAnnualReport != null) {
                    this.translatedAnnualReport.isSealed = true;
                }
                this.isSealed = true;
            });

        this.actionsListener$
            .pipe(ofType(onUnsealAnnualReportSuccessfully), untilDestroyed(this))
            .subscribe(() => {
                this.currentAnnualReport.isSealed = false;
                if (this.translatedAnnualReport != null) {
                    this.translatedAnnualReport.isSealed = false;
                }
                this.isSealed = false;
            });

        // Reset the sealAfterSave guard once the seal operation completes (success or failure).
        // This ensures updateAnnualReportData is skipped for all intermediate store emissions
        // triggered between dispatching the seal and receiving its result.
        this.actionsListener$
            .pipe(ofType(onSealAnnualReportSuccessfully, onSealAnnualReportFailed), untilDestroyed(this))
            .subscribe(() => {
                // sealAfterSave is reset here (synchronously) before the async chain
                // reaches the subscribe callback, so skipAutofilledAfterSeal guards
                // handleAutofilledAnnualReport there instead.
                this.sealAfterSave = false;
                this.skipAutofilledAfterSeal = true;
            });

        this.actionsListener$
            .pipe(ofType(onUnsealAnnualReportSuccessfully, onUnsealAnnualReportFailed), untilDestroyed(this))
            .subscribe(() => {
                this.unsealInProgress = false;
                // Mark that the next autofill emission should be skipped. unsealInProgress
                // is reset here (synchronously) before the async chain reaches the
                // subscribe callback, so it cannot guard handleAutofilledAnnualReport there.
                this.skipAutofilledAfterUnseal = true;
            });

        this.providerOfAnnualReports
            .getError$()
            .pipe(untilDestroyed(this))
            .subscribe((error: HttpErrorResponse) => this.handleErrors(error));

        this.actionsListener$.pipe(ofType(printAnnualReport), untilDestroyed(this)).subscribe(() => {
            this.showSpinner = true;
        });
        this.actionsListener$
            .pipe(ofType(onPrintAnnualReportSuccessfully), untilDestroyed(this))
            .subscribe((result) => {
                this.showSpinner = false;
                if (!this.printWindow) {
                    alert('Please disable your Pop-up blocker and try again.');
                    return;
                }
                this.printWindow.location = result.payload.url;
                if (this.printWindow.closed || typeof this.printWindow.closed == 'undefined') {
                    alert('Please disable your Pop-up blocker and try again.');
                }
            });
        this.actionsListener$.pipe(ofType(onPrintAnnualReportFailed), untilDestroyed(this)).subscribe(() => {
            this.showSpinner = false;
            this.printWindow.close();
        });

        this.actionsListener$
            .pipe(ofType(printAnnualReportUsingPdfTron.printAnnualReportUsingPdfTron), untilDestroyed(this))
            .subscribe(() => {
                this.showSpinner = true;
            });
        this.actionsListener$
            .pipe(ofType(printAnnualReportUsingPdfTron.printAnnualReportUsingPdfTronSuccess), untilDestroyed(this))
            .subscribe((result) => {
                this.showSpinner = false;
                if (!this.printWindow) {
                    alert('Please disable your Pop-up blocker and try again.');
                    return;
                }
                this.printWindow.location = result.payload.url;
                if (this.printWindow.closed || typeof this.printWindow.closed == 'undefined') {
                    alert('Please disable your Pop-up blocker and try again.');
                }
            });
        this.actionsListener$
            .pipe(ofType(printAnnualReportUsingPdfTron.printAnnualReportUsingPdfTronFailed), untilDestroyed(this))
            .subscribe(() => {
                this.showSpinner = false;
                this.printWindow.close();
            });

        // PDF V2 listeners
        this.actionsListener$
            .pipe(ofType(fromActions.printAnnualReportUsingPdfTronV2.printAnnualReportUsingPdfTronV2Success), untilDestroyed(this))
            .subscribe((result) => {
                if (!this.printWindow) {
                    alert('Please disable your Pop-up blocker and try again.');
                    return;
                }
                this.printWindow.location.href = result.payload.pdfUrl;
                if (this.printWindow.closed || typeof this.printWindow.closed == 'undefined') {
                    alert('Please disable your Pop-up blocker and try again.');
                }
            });
        this.actionsListener$
            .pipe(ofType(fromActions.printAnnualReportUsingPdfTronV2.printAnnualReportUsingPdfTronV2Failed), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.document.body.innerHTML = `<h3>Error generating PDF</h3><p>Please try again.</p>`;
                }
            });

        // Word V2 listeners
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportToWordV2.exportAnnualReportToWordV2Success), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.close();
                }
            });
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportToWordV2.exportAnnualReportToWordV2Failed), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.document.body.innerHTML = `<h3>Error generating Word document</h3><p>Please try again.</p>`;
                }
            });

        // Excel V2 listeners
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportExcelV2.exportAnnualReportExcelV2Success), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.close();
                }
            });
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportExcelV2.exportAnnualReportExcelV2Failed), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.document.body.innerHTML = `<h3>Error generating Excel file</h3><p>Please try again.</p>`;
                }
            });

        // Excel Structured V2 listeners
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportToExcelStructuredV2.exportAnnualReportToExcelStructuredV2Success), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.close();
                }
            });
        this.actionsListener$
            .pipe(ofType(fromActions.exportAnnualReportToExcelStructuredV2.exportAnnualReportToExcelStructuredV2Failed), untilDestroyed(this))
            .subscribe(() => {
                if (this.printWindow) {
                    this.printWindow.document.body.innerHTML = `<h3>Error generating Excel file</h3><p>Please try again.</p>`;
                }
            });

        this.actionsListener$
            .pipe(
                ofType(
                    getTemplatesTargetTranslations.failure,
                    translationsActions.onGetSettingsTargetTranslationsFailed,
                ),
                untilDestroyed(this),
            )
            .subscribe(() => {
                // in case any failure happen in translation we wont fail the whole page but we'll only show the report
                this.dataState = DataState.Success;
                this.handlePrintPreview();
                this.printPreviewLocalesAvailable = [this.reportLocale];
            });

        this.appStateDispatcher
            .getSupportOperation()
            .pipe(untilDestroyed(this))
            .subscribe((supportActivated: boolean) => {
                this.supportOperation = supportActivated;
                this.updateFooterExtraButtonActions();
            });
    }

    public onLocaleTabChanged(activeLocale: string): void {
        debugLang('onLocaleTabChanged', activeLocale);
        if (activeLocale.toLowerCase() !== this.unsavedTranslationLocale) {
            this.dropUnsavedTranslation();
        }
        this.activeLocale = activeLocale.toLowerCase();

        this.previousDateTitleDefaultValue = this.i18n.t(localizationKeys.aumico_reports_print_title_establishment, {
            lng: this.activeLocale,
        }) as string;

        if (this.currentAnnualReport === undefined) {
            return;
        }

        if (activeLocale.toLowerCase() === this.reportLocale) {
            this.translatedAnnualReport = cloneDeep<IAnnualReport>(this.currentAnnualReport);
            this.predifinedLables = this.localeToPredifinedLables.get(this.reportLocale);
            this.translatedFinstatement = cloneDeep(this.currentFinStatements);
        } else if (this.localeToAnnualReport.get(this.activeLocale) != null) {
            this.translatedAnnualReport = this.localeToAnnualReport.get(this.activeLocale);
            this.predifinedLables = this.localeToPredifinedLables.get(this.activeLocale);
            this.translatedFinstatement = this.localeToTranslatedFinStatement.get(this.activeLocale);
        } else {
            const annualReport = cloneDeep<IAnnualReport>(this.currentAnnualReport);
            const translatedAnnualReport = new TranslatedAnnualReport(annualReport, this.currentFinStatements);
            const annualReportVisitor = new AnnualReportVisitor(
                this.activeLocale,
                this.reportLocale,
                this.translatableItems,
                this.printOptionsDataToBeSaved.reportSectionsTitles,
                this.i18next,
                this.emptyUntranslatedFromVisitors(this.activeLocale),
                this.printOptionsDataToBeSaved.displayOptions,
                this.notesTypes,
            );
            translatedAnnualReport.accept(annualReportVisitor);
            this.translatedAnnualReport = annualReportVisitor.translatedReport;
            this.predifinedLables = annualReportVisitor.predifinedLabels;
            this.translatedFinstatement = annualReportVisitor.translatedFinStatments;
            // Cache data to prevent reprocessing each time
            this.localeToAnnualReport.set(this.activeLocale, this.translatedAnnualReport);
            this.localeToPredifinedLables.set(this.activeLocale, this.predifinedLables);
            this.localeToTranslatedFinStatement.set(this.activeLocale, this.translatedFinstatement);
            this.localeToTranslationMarks.set(this.activeLocale, annualReportVisitor.translationMarks);
        }
        this.refreshPreviewTranslations();
        this.printOptionsData = cloneDeep<IPrintOptions>(this.printOptionsDataToBeSaved);
        this.handlePrintPreview();
        this.updateTranslationState();
    }

    /** Same order as the print-page visitors: the super-table is inserted from the live DOM instead,
     * so it gets the mapping's translation of a text ahead of the AI the same way. */
    private refreshPreviewTranslations(): void {
        const block = this.currentAnnualReport?.translations;
        if (block == null || this.activeLocale === this.reportLocale) {
            this.previewTranslations = block;

            return;
        }
        const bucket = block[this.activeLocale];
        this.previewTranslations = {
            ...block,
            [this.activeLocale]: {
                ...(bucket ?? {}),
                entries: TranslationJobHelper.withMasterData(
                    bucket?.entries,
                    this.translatableItems,
                    this.reportLocale,
                    this.activeLocale,
                ),
            },
        };
    }

    /**
     * FX (REV-21512): the structured Excel export rebuilds super tables as CELLS, while the print
     * DTO carries them as rendered HTML — so the twins have to be computed for it. Same bundle the
     * notes display components derive, via the app-side engine behind FX_NOTES_PRINT_ENGINE.
     * Null on non-FX reports and wherever the provider is absent, which leaves the export as it was.
     */
    private buildFxForExcelExport(): IFxSuperTablePrintContext | null {
        if (this.currentAnnualReport == null) {
            return null;
        }
        const engine = this.injector.get<IFxNotesPrintEngine | null>(FX_NOTES_PRINT_ENGINE, null);

        return engine?.buildSuperTablePrintFx(this.currentAnnualReport) ?? null;
    }

    protected getPdfTronDto(
        notesComponentsHTMLMap?: Map<string, Map<string, string>>,
        printOptionsOverride?: IPrintOptions,
        annualReportOverride?: IAnnualReport,
        finStatementsOverride?: IFinStatements[],
    ): PrintUsingPdfTronDto {
        const rawPrintOptions = printOptionsOverride ?? this.printOptionsDataToBeSaved;
        const annualReport = annualReportOverride ?? this.translatedAnnualReport;
        const finStatements = finStatementsOverride ?? this.translatedFinstatement;

        if (rawPrintOptions == null || annualReport == null || finStatements == null) {
            throw new Error('Print options or annual report data is undefined');
        }

        // REV-21347: guarantee no pre-migration locale-object caption reaches the pdf-tron mapper
        // (e.g. the same-locale render path skips the translation visitor) — resolve them here, the
        // single choke point feeding every print/export render.
        this.coerceFinStatementCaptions(finStatements);

        // REV-20899: reclasses are always included in totals (transactional
        // double-entry model). The legacy `showReClassInSums` flag is force-on
        // here so every read site in the pdf-tron mappers / account-proof
        // mapper picks up reclasses regardless of what was saved on the AR.
        const printOptions: IPrintOptions = {
            ...rawPrintOptions,
            displayOptions: { ...rawPrintOptions.displayOptions, showReClassInSums: true },
        };

        const pdfTronInput = this.pdfTronMapper.mapAnnualReportToPdfTronData(
            annualReport,
            finStatements,
            printOptions,
            this.organization,
            this.annualReportForAutofill,
            this.activeArNavigations,
            this.complementaryReportsTitles,
            this.GICSCodesAndNames,
            this.isFixedAssetsScheduleDataValid,
            this.predifinedLables,
            this.userLocale,
            this.activeLocale,
            this.reportLocale,
            this.logoCompanyBase64,
            notesComponentsHTMLMap,
        );
        const placeholderReplacerVisitor = new PlaceholderReplacerVisitor(this.placeholderMap, this.dateLocalPipe);
        placeholderReplacerVisitor.visit(pdfTronInput);

        const orderedSectionsTitles = pdfTronInput.sections.map((section) => section.title);
        const orderedSectionsIds = pdfTronInput.sections.map((section) => section.sectionId);

        // Create the sectionIdToTitle mapping
        const sectionIdToTitle = {};
        orderedSectionsIds.forEach((id, index) => {
            sectionIdToTitle[id] = orderedSectionsTitles[index];
        });
        pdfTronInput.sectionIdToTitle = sectionIdToTitle;
        pdfTronInput.orderedSectionsTitles = orderedSectionsTitles;

        let annualReportTemplateId: string | undefined;
        let businessModel: PrintUsingPdfTronDto['businessModel'];
        if (this.currentAnnualReport.annualReportTemplate != null) {
            annualReportTemplateId = this.currentAnnualReport.annualReportTemplate._id;
            businessModel = this.currentAnnualReport.annualReportTemplate.businessModel;
        }

        const printUsingPdfTronRequestData: PrintUsingPdfTronDto = {
            data: pdfTronInput,
            orderedSectionsTitles,
            orderedSectionsIds,
            annualReportTemplateId,
            businessModel,
        };

        return printUsingPdfTronRequestData;
    }

    protected exportToWord(): void {
        this.mixpanelService.track(MIXPANEL_EVENTS.EXPORT_TO_WORD_BUTTON_CLICK);

        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );

            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const dataToExport = this.getPdfTronDto(notesComponentsHTMLMap);

        const complementaryReport = this.currentAnnualReport.complementaryReports;
        const contentItems = this.tocService.getTableOfContentEntries(
            this.orderedSectionsTitles,
            this.orderedSectionsIds,
            dataToExport.data.crsA03,
            complementaryReport as unknown as ISectionData[],
            this.notesDetails,
        );
        const labelOrLabelKeys = contentItems.map((item) => item.labelOrLabelKey);
        dataToExport.data.orderedSectionsTitles = labelOrLabelKeys;
        this.providerOfAnnualReports.dispatchExportAnnualReportToWord(dataToExport);
    }

    protected printUsingPdfTron(): void {
        this.mixpanelService.track(MIXPANEL_EVENTS.PDF_TRON_PRINT_BUTTON_CLICK);

        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );

            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const printUsingPdfTronRequestData = this.getPdfTronDto(notesComponentsHTMLMap);

        const complementaryReport = this.currentAnnualReport.complementaryReports;
        const contentItems = this.tocService.getTableOfContentEntries(
            this.orderedSectionsTitles,
            this.orderedSectionsIds,
            printUsingPdfTronRequestData.data.crsA03,
            complementaryReport as unknown as ISectionData[],
            this.notesDetails,
        );
        const labelOrLabelKeys = contentItems.map((item) => item.labelOrLabelKey);
        printUsingPdfTronRequestData.data.orderedSectionsTitles = labelOrLabelKeys;
        this.providerOfAnnualReports.dispatchPrintAnnualReportUsingPdfTron(printUsingPdfTronRequestData);

        this.save();
    }

    protected async printUsingPdfTronV2(): Promise<void> {
        this.mixpanelService.track(MIXPANEL_EVENTS.PDF_TRON_PRINT_BUTTON_CLICK);

        // Open window with loading spinner (must be synchronous to avoid popup blocker)
        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        // Get Firebase ID token for WebSocket authentication
        const user = this.firebaseAuth.currentUser;
        if (!user) {
            console.error('[printUsingPdfTronV2] No authenticated user found');
            if (this.printWindow) this.printWindow.close();
            return;
        }
        const token = await user.getIdToken();
        this.notificationsSocketService.connect(token);

        // Prepare data
        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );

            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const printUsingPdfTronRequestData = this.getPdfTronDto(notesComponentsHTMLMap);

        const complementaryReport = this.currentAnnualReport.complementaryReports;
        const contentItems = this.tocService.getTableOfContentEntries(
            this.orderedSectionsTitles,
            this.orderedSectionsIds,
            printUsingPdfTronRequestData.data.crsA03,
            complementaryReport as unknown as ISectionData[],
            this.notesDetails,
        );
        const labelOrLabelKeys = contentItems.map((item) => item.labelOrLabelKey);
        printUsingPdfTronRequestData.data.orderedSectionsTitles = labelOrLabelKeys;
        this.providerOfAnnualReports.dispatchPrintAnnualReportUsingPdfTronV2(printUsingPdfTronRequestData);

        this.save();
    }

    protected async exportToWordV2(): Promise<void> {
        this.mixpanelService.track(MIXPANEL_EVENTS.EXPORT_TO_WORD_BUTTON_CLICK);

        // Open window with loading spinner (must be synchronous to avoid popup blocker)
        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        // Get Firebase ID token for WebSocket authentication
        const user = this.firebaseAuth.currentUser;
        if (!user) {
            console.error('[exportToWordV2] No authenticated user found');
            if (this.printWindow) this.printWindow.close();
            return;
        }
        const token = await user.getIdToken();
        this.notificationsSocketService.connect(token);

        // Prepare data
        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );
            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const printUsingPdfTronRequestData = this.getPdfTronDto(notesComponentsHTMLMap);

        const complementaryReport = this.currentAnnualReport.complementaryReports;
        const contentItems = this.tocService.getTableOfContentEntries(
            this.orderedSectionsTitles,
            this.orderedSectionsIds,
            printUsingPdfTronRequestData.data.crsA03,
            complementaryReport as unknown as ISectionData[],
            this.notesDetails,
        );
        const labelOrLabelKeys = contentItems.map((item) => item.labelOrLabelKey);
        printUsingPdfTronRequestData.data.orderedSectionsTitles = labelOrLabelKeys;

        this.providerOfAnnualReports.dispatchExportAnnualReportToWordV2(printUsingPdfTronRequestData);

        this.save();
    }

    protected async exportExcelV2(): Promise<void> {
        // Open window with loading spinner (must be synchronous to avoid popup blocker)
        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        // Get Firebase ID token for WebSocket authentication
        const user = this.firebaseAuth.currentUser;
        if (!user) {
            console.error('[exportExcelV2] No authenticated user found');
            if (this.printWindow) this.printWindow.close();
            return;
        }
        const token = await user.getIdToken();
        this.notificationsSocketService.connect(token);

        // Prepare data
        const options: IOptions = {
            showAdjustmentInSums: false,
            showUID: false,
            showRatios: false,
            showCover: false,
            showTOC: false,
            showNotesInDetailInToc: false,
            showCompanyInfos: false,
            showShareholderInfo: this.printOptionsDataToBeSaved.displayOptions.showShareholderInformation,
            disableBalanceSheetPageBreak: false,
            displayAssetsAndLiabilitiesInSamePage: false,
            textColor: this.printOptionsDataToBeSaved.styleOptions.textColor,
            titleColor: this.printOptionsDataToBeSaved.styleOptions.titleColor,
            highlightColor: this.printOptionsDataToBeSaved.styleOptions.backgroundColor,
            backgroundColorPY: this.printOptionsDataToBeSaved.styleOptions.backgroundColorPY,
            tableHeaderColor: this.printOptionsDataToBeSaved.styleOptions.tableHeaderColor,
            tableFooterColor: this.printOptionsDataToBeSaved.styleOptions.tableFooterColor,
            showReportCompanyLogo: this.printOptionsDataToBeSaved.displayOptions.showCompanyLogo,
            internalLabel: 'Intern',
            showRoundingDisclaimer: false,
            showAccounts: this.printOptionsDataToBeSaved.displayOptions.showAccounts,
            repeatAppendixTitle: this.printOptionsDataToBeSaved.displayOptions.repeatAppendixTitle,
            isSealed: this.currentAnnualReport.isSealed ?? false,
            showPageNumbers: true,
        };

        const complementaryReportsAsAppendix = this.currentAnnualReport.complementaryReports?.filter(
            (report) => report.printLocation === PrintLocation.APPENDIX,
        );

        // REV-20899: clone+force the flag on so excel export includes reclasses.
        const printOptionsWithReclasses = this.forceReclassInSumsOn(cloneDeep<IPrintOptions>(this.printOptionsDataToBeSaved));
        const pdfTronSections = this.pdfTronMapper.getSections(
            this.translatedAnnualReport,
            printOptionsWithReclasses,
            this.annualReportForAutofill,
            printOptionsWithReclasses.reportOrder,
            options,
            this.predifinedLables,
            this.userLocale,
            this.activeLocale,
            this.reportLocale,
            complementaryReportsAsAppendix,
            this.currentFinStatements,
        );

        const exportData = this.excelMapper.mapPdfTronSectionsDataToExcelData(pdfTronSections);
        this.providerOfAnnualReports.dispatchExportAnnualReportExcelV2(exportData);
    }

    protected async exportExcelStructuredV2(): Promise<void> {
        // Open window with loading spinner (must be synchronous to avoid popup blocker)
        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        // Get Firebase ID token for WebSocket authentication
        const user = this.firebaseAuth.currentUser;
        if (!user) {
            console.error('[exportExcelStructuredV2] No authenticated user found');
            if (this.printWindow) this.printWindow.close();
            return;
        }
        const token = await user.getIdToken();
        this.notificationsSocketService.connect(token);

        // Prepare data
        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );

            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const excelDataToExport = this.getPdfTronDto(notesComponentsHTMLMap);
        this.stripAopHtmlForExcel(excelDataToExport);

        // Include extra Excel content (DATEV Sammelkonten/Kontokorrent) if available
        const excelDataToExportWithExtra = this.currentAnnualReport?.extraExcelContent
            ? { ...excelDataToExport, extraExcelData: this.currentAnnualReport.extraExcelContent }
            : excelDataToExport;

        let notesCopy = [...(this.translatedAnnualReport?.notes?.accordions || [])];
        if (this.printOptionsDataToBeSaved.displayOptions.hideEmptyLines) {
            notesCopy = this.notesEmptyLinesRemovalHelper.removeEmptyLinesOfNotes(notesCopy, this.activeLocale);
        }

        const numberedNotes = this.notesNumberingHelper.applyNumbering(
            notesCopy,
            this.activeLocale,
            false,
            this.defaultLanguage,
        );
        const numberedTitles = this.notesNumberingHelper.createNumberingObject(numberedNotes, this.activeLocale);

        const finalData = this.excelMapper.prepareNotesDataForExcelStructuredExport(
            notesCopy,
            excelDataToExportWithExtra.data,
            this.activeLocale,
            this.currentAnnualReport?.generalInformation?.balanceSheetDate,
            this.currentAnnualReport?.generalInformation?.balancePreviousYearDate,
            numberedTitles,
            this.placeholderMap,
            this.buildFxForExcelExport(),
            this.currentAnnualReport,
        );

        excelDataToExportWithExtra.data = finalData;

        this.providerOfAnnualReports.dispatchExportAnnualReportExcelStructuredV2(excelDataToExportWithExtra);

        this.save();
    }

    protected shareReportWithUsers(): void {
        const dialogData = this.getInviteToReportDialogData();
        this.openInvitationDialog(dialogData);
    }

    protected getInviteToReportDialogData(): IInvitationDialogData {
        return {
            titleLocalizationKey: localizationKeys.aumico_reports_share_annual_report_dialog_title,
            contentMessage: localizationKeys.aumico_reports_share_annual_report_dialog_content,
            emailInputLabelKey: localizationKeys.aumico_reports_share_annual_report_dialog_input_label,
            emailInputPlaceholderKey: localizationKeys.aumico_reports_share_annual_report_dialog_input_placeholder,
            actionBtnTextKey: localizationKeys.aumico_reports_share_annual_report_dialog_save_button,
            hasMessage: true,
            action: (emails: string[], emailMessage: string) => this.onShareClick(emails, emailMessage),
        };
    }

    protected initializeEqualityCheckData(): void {
        this.equalityCheckDataPreviousYear = {
            isMappingAssetsAndLiabilitiesConsistent: false,
            isMappingProfitIncomeAndProfitFliConsistent: false,
        };

        this.equalityCheckDataCurrentYear = {
            isMappingAssetsAndLiabilitiesConsistent: false,
            isMappingProfitIncomeAndProfitFliConsistent: false,
        };
    }

    // True when this print shows no comparison column.
    private hasNoPreviousData(displayOptions: IDisplayOptions | undefined): boolean {
        return PreviousPeriodHelper.hidesPreviousPeriod(
            this.currentAnnualReport?.generalInformation,
            displayOptions,
        );
    }

    protected updatePrintOptions(printOptions: IPrintOptions): void {
        this.printDisplayOptions = cloneDeep<IDisplayOptions>(printOptions.displayOptions);
        this.noPreviousData = this.hasNoPreviousData(printOptions.displayOptions);
        // REV-20899: reclassifications are now an integral part of every
        // commercial total (transactional double-entry model). The
        // `showReClassInSums` toggle has been removed from the print options
        // UI; force it on here so the legacy mappers/helpers that still read
        // the flag include reclasses unconditionally.
        this.printDisplayOptions.showReClassInSums = true;
        this.printStyleOptions = cloneDeep<IStyleOptions>(printOptions.styleOptions);
        this.printSignatureOptions = cloneDeep<ISignatureOptions>(printOptions.signatureOptions);

        this.recountTranslationGaps();
        this.cashFlowPrintOptions$.next({ ...this.printDisplayOptions });
        this.adjustmentsAndReclassesPrintOptions$.next({ ...this.printDisplayOptions });

        //Fill Print View
        if (
            this.organization == null ||
            this.printOptionsDataToBeSaved == null ||
            this.currentAnnualReport == null ||
            this.pdfTronMapper == null
        ) {
            return;
        }
        this.handlePrintPreview();
    }

    /**
     * REV-21347: when the print locale equals the report locale the translation visitor is skipped
     * and the RAW finStatements are rendered as-is. Un-migrated FLI/group captions there may still
     * be pre-migration locale-objects; resolve them to the report-language string so the
     * balance/income sheets never print "[object Object]".
     */
    private coerceFinStatementCaptions(finStatements: IFinStatements[] | undefined): void {
        const locale = this.reportLocale;
        const seen = new Set<unknown>();
        const walk = (node: unknown): void => {
            if (node == null || typeof node !== 'object' || seen.has(node)) return;
            seen.add(node);
            if (Array.isArray(node)) {
                node.forEach(walk);
                return;
            }
            const obj = node as Record<string, unknown>;
            for (const key of ['caption', 'title', 'totalName']) {
                if (obj[key] != null && typeof obj[key] === 'object') {
                    obj[key] = getCaptionString(obj[key] as never, locale);
                }
            }
            for (const value of Object.values(obj)) {
                if (value != null && typeof value === 'object') walk(value);
            }
        };
        for (const fs of finStatements ?? []) {
            walk(fs?.templateAndAccountsMapping?.template?.group);
        }
    }

    protected handlePrintPreview(): void {
        const complementaryReportsSelection =
            this.printOptionsDataToBeSaved?.displayOptions?.complementaryReportsSelection;
        this.orderedSectionsIds = ReportSectionsHelper.getOrderedSectionIds(
            this.printDisplayOptions,
            this.activeArNavigations,
            this.complementaryReportsTitles,
            this.translatedAnnualReport,
            this.isFixedAssetsScheduleDataValid,
            complementaryReportsSelection,
        );

        if (this.printOptionsDataToBeSaved) {
            this.orderedSectionsIds = ReportSectionsHelper.getOrderedSectionIds(
                this.printOptionsDataToBeSaved.displayOptions,
                this.activeArNavigations,
                this.complementaryReportsTitles,
                this.translatedAnnualReport,
                this.isFixedAssetsScheduleDataValid,
                complementaryReportsSelection,
            );
            this.printOptionsDataToBeSaved.reportOrder = cloneDeep<SectionIds[]>(this.orderedSectionsIds);
        }

        if (this.printOptionsDataToBeSaved == null) {
            return;
        }

        const printUsingPdfTronRequestData = this.getPdfTronDto();

        this.complementaryReportsAtTheStart = printUsingPdfTronRequestData.data.crsA01;
        this.complementaryReportsAtTheEnd = printUsingPdfTronRequestData.data.crsA02;
        this.complementaryReportsAsAppendix = printUsingPdfTronRequestData.data.crsA03;

        if (this.defaultPrintOptionsValue != null) {
            this.defaultPrintOptionsValue.reportOrder = cloneDeep<SectionIds[]>(this.orderedSectionsIds);
        }

        this.orderedSectionsTitles = printUsingPdfTronRequestData.orderedSectionsTitles;
        this.notesDetails = printUsingPdfTronRequestData.data.notesDetails;
        this.providerOfAnnualReports.dispatchPrintView(printUsingPdfTronRequestData);
        // Every rebuild drops the marks (a toggled part, a new AOP snapshot, …): an open review paints
        // them again, so the marks and the "save" button never part ways.
        this.paintTranslationMarking();
    }

    protected getAttachmentReferences(): void {
        this.annualReport$
            .pipe(
                filter((annualReport: IAnnualReport) => annualReport != null && annualReport.notes != null),
                take(1),
                untilDestroyed(this),
            )
            .subscribe((annualReport: IAnnualReport) =>
                this.handleAttachmentReferencesFromActiveAnnualReport(annualReport.notes as INotes),
            );
    }

    protected handleAttachmentReferencesFromActiveAnnualReport(notes: INotes): void {
        this.notesAccordions = notes.accordions;
        this.handleReferences(notes.accordions);
    }

    handleReferences(accordions: INotesSection[]): void {
        if (this.reportLocale == null) {
            return;
        }
        this.balanceIncomeAttachmentReferences = this.attachmentReferencesHelper.getBalanceIncomeAttachmentReferences(
            accordions,
            this.reportLocale,
        );
    }

    protected handleAutofilledAnnualReport(annualReportForAutofill: IAnnualReport): void {
        // if annualreport for autofill has print options AND no print options is saved in the current annual report, then we apply autofill for printoptions
        if (
            annualReportForAutofill.printOptions != null &&
            this.currentAnnualReport != null &&
            this.currentAnnualReport.printOptions == null
        ) {
            this.printOptionsData = this.printPageHelper.preparePrintOptionsAutofillData(
                annualReportForAutofill.printOptions,
                this.previousDateTitleDefaultValue,
                this.currentDateTitleDefaultValue,
                this.currentAnnualReport?.setupData?.reportType,
                annualReportForAutofill.setupData?.reportType

            );
            this.printOptionsDataToBeSaved = this.forceReclassInSumsOn(cloneDeep(this.printOptionsData));
        }
        // we are deciding here which fin statement to use instead of using the ngrx data
        // we are deciding with the same logic as there. If fcp was used, we use the fcp output
        // othersie the normal fin statements
        this.previousYearFliIdToAccounts = this.printPageHelper.getFliIdToAccountsForAnnualReport(
            annualReportForAutofill.fcp
                ? annualReportForAutofill.fcp.outputFinStatements
                : annualReportForAutofill.finStatements,
        );
    }

    protected checkCashFlowWithPrintOptionsChanges(): void {
        if (this.currentAnnualReport == null) {
            return;
        }
        if (!this.printDisplayOptions.showAdjustmentInSums) {
            return;
        }
        if (this.orderedSectionsIds.includes(SectionIds.CASHFLOW)) {
            this.openWarningDialog();
        }
    }

    protected openWarningDialog(): void {
        const popupData: IPopupData = {
            titleLocalizationKey: localizationKeys.aumico_reports_warning_popup_warning_title,
            isContentHtmlType: false,
            contentMessage: localizationKeys.aumico_reports_print_page_adjustments_reclasses_warning,
        };

        this.matDialog.open<AumicoInformationPopupComponent, IPopupData, void>(AumicoInformationPopupComponent, {
            width: '80%',
            data: popupData,
            panelClass: MAT_DIALOG_CUSTOM_CLASS,
        });
    }

    protected updateAnnualReportData(annualReport: IAnnualReport, finStatements: IFinStatements[]): void {
        debug('updateAnnualReportData', annualReport);

        this.currentAnnualReport = cloneDeep<IAnnualReport>(annualReport);
        this.currentFinStatements = cloneDeep<IAnnualReport>(finStatements);
        this.translatedAnnualReport = cloneDeep<IAnnualReport>(this.currentAnnualReport);
        this.translatedFinstatement = cloneDeep<IFinStatements[]>(this.currentFinStatements);
        this.reportLocale = annualReport.locale.toLowerCase();
        if (this.activeLocale === undefined || this.activeLocale === null) {
            debugLang('updateAnnualReportData -> Update activeLocale: ', this.activeLocale, this.reportLocale);
            this.activeLocale = this.reportLocale;
        } else {
            debugLang('updateAnnualReportData -> Remain the same activeLocale: ', this.activeLocale, this.reportLocale);
        }

        const annualReportVisitor = new AnnualReportVisitor(
            this.reportLocale,
            this.reportLocale,
            undefined,
            this.printOptionsDataToBeSaved != null
                ? this.printOptionsDataToBeSaved.reportSectionsTitles
                : this.currentAnnualReport.printOptions?.reportSectionsTitles,
            this.i18next,
        );
        this.predifinedLables = annualReportVisitor.predifinedLabels;
        this.localeToPredifinedLables.set(this.reportLocale, this.predifinedLables);

        if (this.printOptionsDataToBeSaved && this.translatedAnnualReport != null) {
            if (this.activeLocale.toLowerCase() === this.reportLocale) {
                this.translatedAnnualReport = cloneDeep<IAnnualReport>(this.currentAnnualReport);
                this.predifinedLables = this.localeToPredifinedLables.get(this.reportLocale);
                this.translatedFinstatement = cloneDeep(this.currentFinStatements);
            } else if (this.localeToAnnualReport.get(this.activeLocale) != null) {
                this.translatedAnnualReport = this.localeToAnnualReport.get(this.activeLocale);
                this.predifinedLables = this.localeToPredifinedLables.get(this.activeLocale);
                this.translatedFinstatement = this.localeToTranslatedFinStatement.get(this.activeLocale);
            } else {
                const annualReport = cloneDeep<IAnnualReport>(this.currentAnnualReport);
                const translatedAnnualReport = new TranslatedAnnualReport(annualReport, this.currentFinStatements);
                const annualReportVisitor = new AnnualReportVisitor(
                    this.activeLocale,
                    this.reportLocale,
                    this.translatableItems,
                    this.printOptionsDataToBeSaved.reportSectionsTitles,
                    this.i18next,
                    this.emptyUntranslatedFromVisitors(this.activeLocale),
                    this.printOptionsDataToBeSaved.displayOptions,
                    this.notesTypes,
                );
                translatedAnnualReport.accept(annualReportVisitor);
                this.translatedAnnualReport = annualReportVisitor.translatedReport;
                this.predifinedLables = annualReportVisitor.predifinedLabels;
                this.translatedFinstatement = annualReportVisitor.translatedFinStatments;
                // Cache data to prevent reprocessing each time
                this.localeToAnnualReport.set(this.activeLocale, this.translatedAnnualReport);
                this.localeToPredifinedLables.set(this.activeLocale, this.predifinedLables);
                this.localeToTranslatedFinStatement.set(this.activeLocale, this.translatedFinstatement);
                this.localeToTranslationMarks.set(this.activeLocale, annualReportVisitor.translationMarks);
            }
        }

        if (annualReport.complementaryReports != null) {
            this.complementaryReportsTitles = annualReport.complementaryReports.map(
                (complementaryReport) => complementaryReport.title,
            );
        }
        this.onConsistencyInputDataUpdate();
        this.currentYearFliIdToAccounts = this.printPageHelper.getFliIdToAccountsForAnnualReport(
            this.currentFinStatements,
        );
        this.fliIdToType = this.printPageHelper.getFliIdToTypeForAnnualReport(this.currentFinStatements);
        if (annualReport.printOptions != null) {
            this.printDisplayOptions = cloneDeep<IDisplayOptions>(annualReport.printOptions.displayOptions);
            // REV-20899: reclasses are always included in totals (see updatePrintOptions).
            this.printDisplayOptions.showReClassInSums = true;

            this.printStyleOptions = cloneDeep<IStyleOptions>(annualReport.printOptions.styleOptions);

            this.printSignatureOptions = cloneDeep<ISignatureOptions>(annualReport.printOptions.signatureOptions);

            this.printOptionsData =
                this.printOptionsData == null
                    ? annualReport.printOptions
                    : {
                        ...annualReport.printOptions,
                        signatureOptions: {
                            ...(this.printOptionsData.signatureOptions || ({} as ISignatureOptions)),
                            ...(annualReport.printOptions.signatureOptions || {}),
                        },
                        displayOptions: {
                            ...(this.printOptionsData.displayOptions || ({} as IDisplayOptions)),
                            ...(annualReport.printOptions.displayOptions || {}),
                        },
                        styleOptions: {
                            ...(this.printOptionsData.styleOptions || ({} as IStyleOptions)),
                            ...(annualReport.printOptions.styleOptions || {}),
                        },
                        reportOrder: cloneDeep<SectionIds[]>(this.orderedSectionsIds),
                    };
            this.printOptionsDataToBeSaved = this.forceReclassInSumsOn(cloneDeep<IPrintOptions>(this.printOptionsData));

            this.onConsistencyInputDataUpdate();
        }

        if (annualReport.generalInformation != null && Object.keys(annualReport.generalInformation).length > 0) {
            this.companyName = annualReport.generalInformation.company?.name;
            this.currency = annualReport.generalInformation.currency?.name;
            this.noPreviousData = this.hasNoPreviousData(this.printOptionsDataToBeSaved?.displayOptions);
            const businessModel =
                annualReport.annualReportTemplate != null
                    ? annualReport.annualReportTemplate.businessModel
                    : AnnualReportBusinessModel.OR;
            this.handlePrintPreviewTargetGroup(businessModel);

            if (PreviousPeriodHelper.hasNoPreviousPeriod(annualReport.generalInformation)) {
                this.previousDateTitleDefaultValue = this.i18n.t(
                    localizationKeys.aumico_reports_print_title_establishment,
                    {
                        lng: this.activeLocale,
                    },
                ) as string;
                this.equalityCheckDataPreviousYear = null;
            } else {
                this.previousDateTitleDefaultValue = this.dateLocalPipe
                    .transform(annualReport.generalInformation.balancePreviousYearDate, 1)
                    .toString();
            }
            this.currentDateTitleDefaultValue = this.dateLocalPipe
                .transform(annualReport.generalInformation.balanceSheetDate)
                .toString();
            this.currentYearIncomeDate =
                this.dateLocalPipe.transform(annualReport.generalInformation.incomeCurrentYearFromDate).toString() +
                '\n' +
                '-' +
                (annualReport.generalInformation.incomeCurrentYearToDate != null
                    ? this.dateLocalPipe.transform(annualReport.generalInformation.incomeCurrentYearToDate).toString()
                    : '');
            this.previousYearIncomeDate = PreviousPeriodHelper.hasNoPreviousPeriod(annualReport.generalInformation)
                ? this.noPreviousDatePlaceholder
                : this.dateLocalPipe.transform(annualReport.generalInformation.incomePreviousYearFromDate).toString() +
                '\n' +
                '-' +
                (annualReport.generalInformation.incomePreviousYearToDate != null
                    ? this.dateLocalPipe
                        .transform(annualReport.generalInformation.incomePreviousYearToDate)
                        .toString()
                    : '');
        }

        if (annualReport.equityMovementSchedule != null) {
            this.disableShowEmsToggle = false;
        }

        if (annualReport.fixedAssetsSchedule != null) {
            this.isFixedAssetsScheduleDataValid =
                this.fixedAssetsScheduleValidationService.isFixedAssetsScheduleDataValidateAgainstMapping(
                    annualReport.fixedAssetsSchedule,
                    finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template,
                );

            if (!this.isFixedAssetsScheduleDataValid) {
                const popupData: IPopupData = {
                    titleLocalizationKey: localizationKeys.aumico_reports_warning_popup_warning_title,
                    isContentHtmlType: false,
                    contentMessage: localizationKeys.aumico_reports_print_page_fixed_assets_schedule_invalid_warning,
                };

                this.matDialog.open<AumicoInformationPopupComponent, IPopupData, void>(
                    AumicoInformationPopupComponent,
                    {
                        width: '600px',
                        data: popupData,
                        panelClass: MAT_DIALOG_CUSTOM_CLASS,
                    },
                );
            }
        }

        if (this.organization != null && this.printOptionsDataToBeSaved != null && this.pdfTronMapper != null) {
            this.handlePrintPreview();
        }
    }

    private handlePrintPreviewTargetGroup(businessModel: string): void {
        this.printPreviewTargetGroup =
            businessModel === AnnualReportBusinessModel.HGB
                ? PrintPreviewTargetGroup.GERMAN
                : PrintPreviewTargetGroup.SWISS;

        this.pdfTronMapper =
            this.printPreviewTargetGroup === PrintPreviewTargetGroup.GERMAN
                ? this.injector.get(PdfTronGermanMapper)
                : this.injector.get(PdfTronSwissMapper);

        this.printDisplayOptions =
            this.printPreviewTargetGroup === PrintPreviewTargetGroup.GERMAN
                ? DEFAULT_GERMAN_DISPLAY_OPTIONS
                : DEFAULT_SWISS_DISPLAY_OPTIONS;
        // REV-20899: reclasses are always included in totals (see updatePrintOptions).
        this.printDisplayOptions = { ...this.printDisplayOptions, showReClassInSums: true };
        this.printSignatureOptions = DEFAULT_SIGNATURE_OPTIONS;
        this.printStyleOptions = DEFAULT_STYLE_OPTIONS;

        this.updateFooterButtons();
    }

    private updateFooterButtons(): void {
        this.footerExtraButtonActions = [
            {
                label: this.i18n.t('aumico_reports_annualreport_navigation_print_using_pdf_tron') as string,
                action: () => this.printUsingPdfTron(),
                disabled: this.blockExport,
                icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
            },
            {
                label: this.i18n.t('aumico_annual_report_export_to_word') as string,
                action: () => this.exportToWord(),
                disabled: this.blockExport,
                icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
            },
            {
                label: this.i18n.t('aumico_annual_reports_export_excel_structured') as string,
                action: () => this.exportExcelStructured(),
                disabled: this.blockExport,
                icon: 'assets/icons/aumico-pattern-icon-download-white.svg',
                styleClassName: 'new-export-button',
            },
            this.extraPrintButton,
            this.extraPrintButtonV2,
            this.extraWordButtonV2,
            this.extraExcelButtonV2,
            this.extraExcelStructuredButtonV2,
        ];
    }

    private updateFooterExtraButtonActions(): void {
        // If support mode is active, add the OLD export Excel button
        if (this.supportOperation) {
            this.extraPrintButton.styleClassName = 'support-export-button';
            this.extraPrintButtonV2.styleClassName = 'support-export-button';
            this.extraWordButtonV2.styleClassName = 'support-export-button';
            this.extraExcelButtonV2.styleClassName = 'support-export-button';
            this.extraExcelStructuredButtonV2.styleClassName = 'support-export-button';
        } else {
            this.extraPrintButton.styleClassName = 'support-export-button hidden';
            this.extraPrintButtonV2.styleClassName = 'support-export-button hidden';
            this.extraWordButtonV2.styleClassName = 'support-export-button hidden';
            this.extraExcelButtonV2.styleClassName = 'support-export-button hidden';
            this.extraExcelStructuredButtonV2.styleClassName = 'support-export-button hidden';
        }
    }

    private dispatchGetTranslations(): void {
        if (this.currentAnnualReport.importedTaxonomy == null) {
            const settingsTranslationRequest = this.translationMapper.getSettingsTranslationRequest(
                this.currentAnnualReport,
                this.reportLocale,
                this.printPreviewLocalesAvailable,
            );

            this.settingsProvider.dispatchGetSettingsTargetTranslations(settingsTranslationRequest);

            const balanceMappedTemplate =
                this.currentFinStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template;
            const incomeMappedTemplate =
                this.currentFinStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template;

            const templatesTranslationRequest = this.translationMapper.getTemplatesTranslationRequest(
                this.currentAnnualReport,
                balanceMappedTemplate,
                incomeMappedTemplate,
                this.printPreviewLocalesAvailable,
                this.reportLocale,
            );

            this.templateProvider.dispatchGetTemplatesTargetTranslations(templatesTranslationRequest);
        } else {
            this.dataState = DataState.Success;
        }
    }

    updateChangedComponents(oldInput: IAccountMappingFormInput, newInput: IAccountMappingFormInput) {
        const rulesChanged = !this._oneLevelEqual(
            (oldInput && oldInput.sheetSystem) || {},
            (newInput && newInput.sheetSystem) || {},
        );
        if (newInput == null) {
            this.engineBalance = null;
            this.engineIncome = null;
            return;
        }
        debug('newInput', newInput);
        const hasNoOldData = oldInput == null;
        const hasNewAndOldDate = oldInput != null && newInput != null;
        const hasDifferentBalanceData = hasNewAndOldDate && oldInput.balance !== newInput.balance;
        const hasDifferentIncomeDate = hasNewAndOldDate && oldInput.income !== newInput.income;
        if (hasNoOldData || hasDifferentBalanceData || rulesChanged) {
            this.engineBalance = this.financialStatementMapper.getWorkingEngineFromData(
                newInput.balance,
                newInput.sheetSystem,
                { startDate: newInput.dates.balanceStartDate, endDate: newInput.dates.balanceEndDate },
                this.activeLocale,
                this.defaultLanguage,
                this.currentAnnualReport.generalInformation?.isPreviousDataTakenFromPreviousAnnualReport,
            );
        }
        if (hasNoOldData || hasDifferentIncomeDate || rulesChanged) {
            this.engineIncome = this.financialStatementMapper.getWorkingEngineFromData(
                newInput.income,
                newInput.sheetSystem,
                { startDate: newInput.dates.incomeStartDate, endDate: newInput.dates.incomeEndDate },
                this.activeLocale,
                this.defaultLanguage,
                this.currentAnnualReport.generalInformation?.isPreviousDataTakenFromPreviousAnnualReport,
            );
        }
    }

    _oneLevelEqual(obj1: object, obj2: object) {
        const colobj = { ...obj1, ...obj2 };
        let equal = true;
        for (const key of Object.keys(colobj)) {
            equal = equal && obj1[key] === obj2[key];
            if (!equal) {
                break;
            }
        }
        return equal;
    }

    onPrintOptionsChanged(printOptions: IPrintOptions): void {
        this.printOptionsDataToBeSaved = this.forceReclassInSumsOn(
            cloneDeep<IPrintOptions>({
                ...printOptions,
                reportOrder: this.orderedSectionsIds,
            }),
        );

        this.updatePrintOptions(this.printOptionsDataToBeSaved);
    }

    /**
     * REV-20899: reclasses are an integral part of every commercial total in
     * the transactional double-entry model. The legacy `showReClassInSums`
     * toggle has been removed from the UI; force it on whenever we persist or
     * pass print options downstream so the pdf-tron mappers (which still gate
     * reclass aggregation on this flag) always include them.
     */
    private forceReclassInSumsOn(printOptions: IPrintOptions): IPrintOptions {
        if (printOptions == null) return printOptions;
        printOptions.displayOptions = {
            ...printOptions.displayOptions,
            showReClassInSums: true,
        };
        return printOptions;
    }

    onInitialPrintOptionsReady(printOptions: IPrintOptions): void {
        this.defaultPrintOptionsValue = cloneDeep<IPrintOptions>({
            ...printOptions,
            reportOrder: this.orderedSectionsIds,
            styleOptions: { ...this.printStyleOptions }
        });
    }

    onTriggeringInitialIncomeItemsOptionsPreparationForRatioCalculation(): void {
        this.prepareIncomeItemsOptionsForCalculatingRatio();
    }

    onIncomeItemForCalculatingRatioSelectionChange(
        selectedIncomeItemOptionForCalculatingRatio: IItemForCalculatingRatioOption,
    ): void {
        this.selectedIncomeItemForCalculatingRatio = selectedIncomeItemOptionForCalculatingRatio;
        if (this.printOptionsDataToBeSaved != null) {
            this.printOptionsDataToBeSaved.displayOptions.incomeItemNameForCalculatingRatio =
                selectedIncomeItemOptionForCalculatingRatio.name;
        }
    }
    //translationblockstart
    private static readonly REPORT_PART_LABEL_KEYS: [ReportPart, string][] = [
        ['template', 'aumico_annual_report_translation_part_template'],
        ['accounts', 'aumico_annual_report_translation_part_accounts'],
        ['notes', 'aumico_annual_report_translation_part_notes'],
        ['aop', 'aumico_annual_report_translation_part_aop'],
        ['ems', 'aumico_annual_report_translation_part_ems'],
        ['cashflow', 'aumico_annual_report_translation_part_cashflow'],
        ['complementary', 'aumico_annual_report_translation_part_complementary'],
    ];

    private updateTranslationState(): void {
        const locale = this.activeLocale?.toLowerCase();
        const isReportLanguage = locale == null || locale === this.reportLocale;

        this.recountTranslationGaps();

        if (this.translationReviewLocale !== this.activeLocale) {
            this.translationReviewOpen = false;
        }

        // Always up on a foreign language: a part switched on later can bring gaps, and the review
        // works on master-data translations without any AI run.
        this.showTranslationButton = !isReportLanguage;
        this.translationTargetLanguageKey = LOCALE_LOCALIZATION_KEYS_MAP.get(locale) ?? '';

        const declined =
            this.currentAnnualReport?.translations?.[locale]?.declined === true ||
            this.pendingDeclinedLocales.has(locale);
        if (this.translationGapCount > 0 && !this.isSealed && !declined && !this.isInternalLocaleRebuild) {
            this.openTranslationGapsDialog();
        }
    }

    onManageTranslationClicked(): void {
        this.translationNoNewGaps = false;
        this.recountTranslationGaps();
        if (this.hasTranslationBlock() || this.translationGapCount === 0) {
            this.showTranslationManageDialog = true;
        } else {
            this.openTranslationGapsDialog();
        }
    }

    onTranslateWithAiClicked(): void {
        const gaps = new Set<string>(this.translationGapsByPart.flatMap((part) => part.texts));
        if (gaps.size === 0) {
            this.showTranslationGapsDialog = false;

            return;
        }

        this.translationRequested = new Set(gaps);
        this.translationRunLocale = this.activeLocale;
        this.translationRunState = 'running';
        this.translationRunError = null;
        this.translationProgressDone = null;
        this.translationProgressTotal = null;

        const payload = TranslationJobHelper.buildJobPayload({
            reportLanguage: this.reportLocale,
            targetLanguage: this.activeLocale,
            gaps,
            block: this.currentAnnualReport?.translations,
            translatableItems: this.translatableItems,
            notesTypes: this.notesTypes,
        });

        this.aiAgentProvider.resetSession();
        // Without a token the run never starts, and a run left "running" cannot be cancelled.
        const user = getAuth().currentUser;
        if (user == null) {
            this.failTranslationRun(null);

            return;
        }
        user.getIdToken()
            .then((token) => {
                this.aiAgentProvider.connectSocket(token);
                this.aiAgentProvider.submitJob({ taskType: 'REPORT_TRANSLATE', payload });
            })
            .catch(() => this.failTranslationRun(null));
    }

    /**
     * The notes template the report was built from, to tell a template text from an edited one.
     * Loaded the way the notes page loads it — by the report template's notes template, else by legal
     * form and accounting basis — because both routes are open to org users. The full notes-type list
     * (`GET /api/notes/notesTypes`) is APP_ADMIN only: its 403 signed every customer out (REV-22509).
     */
    private loadNotesTemplateTypes(): void {
        this.providerOfAnnualReports
            .getActiveAnnualReport$()
            .pipe(
                first((report) => report != null),
                switchMap((report) => {
                    const notesTemplateId = report.annualReportTemplate?.notesTemplateId;
                    if (notesTemplateId != null) {
                        return this.notesService.getNotesTemplateById(notesTemplateId).pipe(
                            map((template) =>
                                template.notesTypes.map(({ name, title, componentsOptions, information }) => ({
                                    name,
                                    title,
                                    componentsOptions,
                                    information,
                                })),
                            ),
                        );
                    }
                    const legalForm = report.generalInformation?.company?.legalform?._id;
                    const accountBasis = report.generalInformation?.accountingBasis?._id;
                    if (legalForm == null || accountBasis == null) {
                        return of([]);
                    }
                    return this.notesService
                        .getNotesTemplateByLegalFormAndAccountBasis({ payload: { legalForm, accountBasis } })
                        .pipe(map((notesOfAnnualReport) => notesOfAnnualReport.notes));
                }),
                // Without the template the gap report still works, only every rich text counts as a gap.
                catchError(() => of([])),
                untilDestroyed(this),
            )
            .subscribe((notesTypes) => {
                this.notesTypes = notesTypes ?? [];
            });
    }

    private listenToTranslationRun(): void {
        this.aiAgentProvider.progressEvents$.pipe(untilDestroyed(this)).subscribe((events) => {
            const latest = events[events.length - 1];
            if (this.translationRunState !== 'running' || latest == null) {
                return;
            }
            this.translationProgressDone = typeof latest['translated'] === 'number' ? latest['translated'] : null;
            this.translationProgressTotal = typeof latest['total'] === 'number' ? latest['total'] : null;
        });

        this.aiAgentProvider.error$.pipe(untilDestroyed(this)).subscribe((error) => {
            if (this.translationRunState !== 'running' || error == null) {
                return;
            }
            this.failTranslationRun(error);
        });

        this.aiAgentProvider.status$.pipe(untilDestroyed(this)).subscribe((status) => {
            if (this.translationRunState === 'running' && status === AiAgentStatus.FAILED) {
                this.failTranslationRun(null);
            }
        });

        this.aiAgentProvider.output$.pipe(untilDestroyed(this)).subscribe((output) => {
            if (this.translationRunState !== 'running' || output == null) {
                return;
            }
            this.applyTranslationResult(output);
        });
    }

    private failTranslationRun(error: AiBackendError | null): void {
        this.translationRunError = error;
        this.translationRunState = 'error';
        this.aiAgentProvider.disconnectSocket();
    }

    /** Applied, not saved — the save button writes the block. */
    private applyTranslationResult(output: Record<string, unknown>): void {
        const locale = this.translationRunLocale;
        const { translations, added } = TranslationJobHelper.mergeIntoBlock({
            block: this.currentAnnualReport?.translations,
            output: output as IReportTranslateOutput,
            reportLanguage: this.reportLocale,
            targetLanguage: locale,
            requested: this.translationRequested,
        });

        // Fewer than asked is fine, the rest stay gaps. Nothing at all is a run that did not happen.
        if (added === 0 || this.currentAnnualReport == null) {
            this.failTranslationRun(null);

            return;
        }

        this.aiAgentProvider.disconnectSocket();
        this.translationRunState = 'done';
        this.translationAddedCount = added;
        this.currentAnnualReport.translations = translations;
        this.unsavedTranslationLocale = locale;
        this.refreshTranslatedLocale();
    }

    /** `done` → review: the block stays unsaved until the review's own save button. */
    onTranslationReviewChosen(): void {
        this.showTranslationGapsDialog = false;
        this.translationRunState = 'question';
        this.onReviewTranslationClicked();
    }

    /** `done` → save right away; the review stays reachable via "manage translation". */
    onTranslationSaveNowChosen(): void {
        this.showTranslationGapsDialog = false;
        this.translationRunState = 'question';
        this.onSaveTranslationClicked();
    }

    onSaveTranslationClicked(): void {
        const locale = this.activeLocale;
        const bucket = this.currentAnnualReport?.translations?.[locale];
        if (bucket == null) {
            this.translationReviewOpen = false;
            // Nothing to save, so no rebuild follows that would take the marks away.
            this.paintTranslationMarking();

            return;
        }

        this.translationReviewOpen = false;
        this.writeTranslations(locale, (translations) => {
            translations[locale] = bucket;
        });
    }

    onRefreshTranslationGapsClicked(): void {
        this.refreshTranslatedLocale();
        this.translationNoNewGaps = this.translationGapCount === 0;
        if (!this.translationNoNewGaps) {
            this.showTranslationManageDialog = false;
            this.openTranslationGapsDialog();
        }
    }

    onReviewTranslationClicked(): void {
        this.showTranslationManageDialog = false;
        this.translationReviewOpen = true;
        this.translationReviewLocale = this.activeLocale;
        this.paintTranslationMarking();
    }

    private listenToMarkClicks(): void {
        if (this.translationMarkClickListener != null) {
            return;
        }
        this.translationMarkClickListener = (event: MouseEvent) => {
            const mark = TranslationMarkingHelper.markOfClick(event.target);
            if (mark == null) {
                return;
            }
            this.translationEditSource = mark.source;
            this.translationEditMark = {
                element: mark.element,
                occurrence: TranslationMarkingHelper.marksOf(this.getPreviewRoot(), mark.source).indexOf(mark.element),
            };
            // What this spot shows — master data, AI or a correction — not the block entry, which can
            // differ (master data wins over the block) or be missing (master-data-only texts).
            this.translationEditValue = mark.shown;
            this.translationEditIsHtml = TranslationEditHtml.isHtml(mark.shown);
        };
        document.addEventListener('click', this.translationMarkClickListener);
    }

    private stopListeningToMarkClicks(): void {
        if (this.translationMarkClickListener != null) {
            document.removeEventListener('click', this.translationMarkClickListener);
            this.translationMarkClickListener = null;
        }
    }

    onTranslationEditCancelled(): void {
        this.translationEditSource = null;
        this.translationEditValue = '';
        this.translationEditMark = null;
    }

    get translationEditEmpty(): boolean {
        return this.plainText(this.translationEditValue).length === 0;
    }

    onTranslationRichInput(field: HTMLDivElement): void {
        this.translationEditValue = TranslationEditHtml.read(field);
    }

    /** Pasted text arrives without its formatting, so Word or a web page cannot bring foreign markup in. */
    onTranslationRichPaste(event: ClipboardEvent): void {
        event.preventDefault();
        document.execCommand('insertText', false, event.clipboardData?.getData('text/plain') ?? '');
    }

    /** `hasUserEdited` outranks master data and AI when the visitor inserts it, and applies at
     * every spot with the same source text. */
    onTranslationEditSaved(): void {
        const source = this.translationEditSource;
        const value = this.translationEditValue.trim();
        if (source == null || this.translationEditEmpty || this.currentAnnualReport == null) {
            return;
        }

        const locale = this.activeLocale;
        const block = this.currentAnnualReport.translations ?? {};
        const bucket = block[locale] ?? { entries: {} };
        this.currentAnnualReport.translations = {
            ...block,
            [locale]: {
                ...bucket,
                entries: { ...bucket.entries, [source]: { value, hasUserEdited: true } },
            },
        };
        this.unsavedTranslationLocale = locale;

        // The rebuild replaces the whole preview and moves the scroll: remember where the corrected
        // mark stood on screen, so the next paint puts it back exactly there.
        const mark = this.translationEditMark;
        this.translationScrollAnchor =
            mark != null && mark.element.isConnected && mark.occurrence >= 0
                ? { source, occurrence: mark.occurrence, top: mark.element.getBoundingClientRect().top }
                : null;
        this.translationEditMark = null;

        this.translationEditSource = null;
        this.translationEditValue = '';
        this.translationReviewOpen = true;
        this.translationReviewLocale = locale;
        this.refreshTranslatedLocale();
    }

    private paintTranslationMarking(): void {
        const root = this.getPreviewRoot();
        if (!this.translationReviewOpen) {
            TranslationMarkingHelper.clear(root);
            this.stopListeningToMarkClicks();

            return;
        }
        this.listenToMarkClicks();

        // Exactly what `resolve` inserted for this language: hand corrections, AI entries, standard
        // translations and gaps — everything a correction can reach, nothing it cannot.
        const values: TranslationMarks = this.localeToTranslationMarks.get(this.activeLocale) ?? new Map();

        // The preview is rebuilt on every refresh, so paint after Angular has rendered it — but before
        // the browser shows it: the marks are wider than the plain text, and a frame without them
        // makes the rows jump.
        requestAnimationFrame(() => {
            TranslationMarkingHelper.mark(this.getPreviewRoot(), values, {
                accountNumbersShown: this.printOptionsDataToBeSaved?.displayOptions?.showAccountNumbers === true,
                // The same words the print mappers put around the texts in this language.
                totalWord: this.predifinedLables?.get(
                    localizationKeys.aumico_reports_annualreport_page_print_account_mapping_label_total,
                ),
                wordBeforeCurrency: this.predifinedLables?.get(
                    localizationKeys.aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency,
                ),
            });
            this.restoreTranslationScroll();
        });
    }

    /** After a correction: scrolls so the corrected mark stands where it stood before the rebuild. */
    private restoreTranslationScroll(): void {
        const anchor = this.translationScrollAnchor;
        this.translationScrollAnchor = null;
        if (anchor == null) {
            return;
        }
        const mark = TranslationMarkingHelper.marksOf(this.getPreviewRoot(), anchor.source)[anchor.occurrence];
        if (mark == null) {
            return;
        }
        TranslationMarkingHelper.scrollParent(mark).scrollTop += mark.getBoundingClientRect().top - anchor.top;
    }

    private getPreviewRoot(): HTMLElement | null {
        return document.querySelector<HTMLElement>(
            `.mat-tab-body-active .${PRINT_PREVIEW_CLASS_NAME_SELECTOR}`,
        );
    }

    onTranslationDialogCancelled(): void {
        if (this.translationRunState === 'running') {
            return;
        }
        this.showTranslationGapsDialog = false;
    }

    onTranslationLaterClicked(): void {
        this.showTranslationGapsDialog = false;
        this.pendingDeclinedLocales.add(this.activeLocale);
    }

    override ngOnDestroy(): void {
        this.pendingDeclinedLocales.forEach((locale) => this.declineTranslation(locale, true));
        this.pendingDeclinedLocales.clear();
        // Leaving with the review open would otherwise keep the listener — and this page — alive.
        this.stopListeningToMarkClicks();
        // A running job's socket is otherwise only closed by its result, which nobody reads anymore.
        if (this.translationRunState === 'running') {
            this.aiAgentProvider.disconnectSocket();
        }
        super.ngOnDestroy();
    }

    onTranslationUndoConfirmed(): void {
        this.showTranslationUndoDialog = false;
        this.undoTranslation(this.activeLocale);
    }

    plainText(value: string): string {
        return value.replace(/<[^>]*>/g, '').trim();
    }

    onToggleGapPart(labelKey: string): void {
        this.translationExpandedPart = this.translationExpandedPart === labelKey ? null : labelKey;
    }

    private recountTranslationGaps(): void {
        const locale = this.activeLocale?.toLowerCase();
        const isReportLanguage = locale == null || locale === this.reportLocale;

        this.translationGapsByPart = isReportLanguage ? [] : this.countGapsByPart();
        this.translationGapCount = this.translationGapsByPart.reduce((sum, part) => sum + part.count, 0);
    }

    private openTranslationGapsDialog(): void {
        this.recountTranslationGaps();
        this.translationExpandedPart = null;
        this.translationRunState = 'question';
        this.translationRunError = null;
        this.showTranslationGapsDialog = true;
    }

    /** One text can sit in two parts; counting it once keeps the parts adding up to the total. */
    private countGapsByPart(): { labelKey: string; count: number; texts: string[] }[] {
        const untranslated = this.untranslatedFromVisitors.get(this.activeLocale);
        if (untranslated == null) {
            return [];
        }

        const counted = new Set<string>();

        return AnnualReportPrintPage.REPORT_PART_LABEL_KEYS.filter(([part]) => this.isPartPrinted(part))
            .map(([part, labelKey]) => {
                const texts: string[] = [];
                untranslated.of(part).forEach((text) => {
                    if (!counted.has(text)) {
                        counted.add(text);
                        texts.push(text);
                    }
                });

                return { labelKey, count: texts.length, texts };
            })
            .filter((part) => part.count > 0);
    }

    private isPartPrinted(part: ReportPart): boolean {
        const options = this.printOptionsDataToBeSaved?.displayOptions;
        switch (part) {
            case 'accounts':
                return (
                    options?.showAccounts !== false ||
                    options?.showAccountProofForBalance === true ||
                    options?.showAccountProofForIncome === true
                );
            case 'notes':
                return options?.showNotes !== false;
            case 'aop':
                return options?.showAop !== false;
            case 'cashflow':
                return options?.showCfs !== false;
            case 'ems':
                return options?.showEms !== false;
            case 'complementary':
                return options?.showComplementaryReports !== false;
            default:
                return true;
        }
    }

    hasTranslationBlock(): boolean {
        const entries = this.currentAnnualReport?.translations?.[this.activeLocale]?.entries;

        return Object.keys(entries ?? {}).length > 0;
    }

    private declineTranslation(locale: string, outlivesPage = false): void {
        this.writeTranslations(
            locale,
            (translations) => {
                translations[locale] = { ...(translations[locale] ?? { entries: {} }), declined: true };
            },
            outlivesPage,
        );
    }

    /**
     * Undo drops the entries only: it is no "later" (AC-04), so it never sets `declined` — one set
     * earlier by "Später" stays. The rebuild right after is internal, so the dialog asks again only
     * on the next switch to this language (AC-16).
     */
    private undoTranslation(locale: string): void {
        this.writeTranslations(locale, (translations) => {
            translations[locale] = { ...translations[locale], entries: {} };
        });
    }

    /**
     * The raw report, never `currentAnnualReport`: the page reads the reclass-bridged stream, and
     * the save funnel refuses bridged fin statements (REV-20899).
     */
    private writeTranslations(
        locale: string,
        change: (translations: ITranslations) => void,
        // The save on leaving the page must not be cancelled by the page's own teardown.
        outlivesPage = false,
    ): void {
        if (locale == null) {
            return;
        }
        this.providerOfAnnualReports
            .getActiveAnnualReport$()
            .pipe(first((report) => report != null), outlivesPage ? identity : untilDestroyed(this))
            .subscribe((report) => {
                // The store holds exactly what is saved — the other languages' blocks included, and
                // nothing unsaved, so a "later" here never carries along a run nobody has reviewed.
                const translations: ITranslations = { ...(report.translations ?? {}) };
                change(translations);
                // A save from the page takes the print options along as shown: every successful save
                // makes the page treat its current options as saved, so leaving would not save them.
                // Leaving the page keeps the stored ones — those shown may just have been discarded.
                const printOptions = outlivesPage ? report.printOptions : this.printOptionsToSave(report);
                this.dispatchSaveAnnualReport({ ...report, translations, printOptions });
                this.syncStoredReport((stored) => ({ ...stored, translations, printOptions }));

                // Apply in memory too instead of waiting for the store round-trip.
                if (this.currentAnnualReport != null) {
                    this.currentAnnualReport.translations = translations;
                    this.currentAnnualReport.printOptions = printOptions;
                }
                if (locale === this.unsavedTranslationLocale) {
                    this.unsavedTranslationLocale = null;
                }
                this.refreshTranslatedLocale();
            });
    }

    /** The print options as `save()` persists them; the stored ones while the page has none yet. */
    private printOptionsToSave(report: IAnnualReport): IPrintOptions {
        if (this.printOptionsDataToBeSaved == null) {
            return report.printOptions;
        }

        return cloneDeep<IPrintOptions>({
            ...this.printOptionsDataToBeSaved,
            displayOptions: {
                ...this.printOptionsDataToBeSaved.displayOptions,
            },
        });
    }

    /**
     * Brings the store up to what was just saved: nothing writes a save back into it, so the next
     * save would otherwise send the report as it was when the page loaded. The page itself already
     * shows the new state and skips the store's echo.
     */
    private syncStoredReport(change: (report: IAnnualReport) => IAnnualReport): void {
        this.providerOfAnnualReports
            .getActiveAnnualReport$()
            .pipe(first())
            .subscribe((report) => {
                if (report == null) {
                    return;
                }
                this.skipOwnStoreSync = true;
                this.enforceGlobalStateUpdate(change(report));
            });
    }

    /** Leaving a language with an unsaved run or correction drops it: the block goes back to the saved one. */
    private dropUnsavedTranslation(): void {
        const locale = this.unsavedTranslationLocale;
        if (locale == null || this.currentAnnualReport == null) {
            return;
        }
        this.unsavedTranslationLocale = null;
        this.providerOfAnnualReports
            .getActiveAnnualReport$()
            .pipe(first())
            .subscribe((report) => {
                if (this.currentAnnualReport != null) {
                    this.currentAnnualReport.translations = cloneDeep(report?.translations ?? null);
                }
            });
        this.localeToAnnualReport.delete(locale);
        this.localeToPredifinedLables.delete(locale);
        this.localeToTranslatedFinStatement.delete(locale);
        this.localeToTranslationMarks.delete(locale);
    }

    /** A changed block only shows after the cached clone of this language is thrown away. */
    private refreshTranslatedLocale(): void {
        this.localeToAnnualReport.delete(this.activeLocale);
        this.localeToPredifinedLables.delete(this.activeLocale);
        this.localeToTranslatedFinStatement.delete(this.activeLocale);
        this.localeToTranslationMarks.delete(this.activeLocale);
        this.isInternalLocaleRebuild = true;
        try {
            this.onLocaleTabChanged(this.activeLocale);
        } finally {
            this.isInternalLocaleRebuild = false;
        }
    }
    //translationblockend

    private emptyUntranslatedFromVisitors(locale: string): UntranslatedTexts {
        const untranslated = this.untranslatedFromVisitors.get(locale) ?? new UntranslatedTexts();
        untranslated.reset();
        this.untranslatedFromVisitors.set(locale, untranslated);

        return untranslated;
    }

    private setTemplateTranslations(templateTranslations: TemplatesTranslationResponse): void {
        const flattenGroups: TranslationResponse[] = [
            ...templateTranslations.balanceGroups,
            ...templateTranslations.incomeGroups,
        ];
        for (const item of flattenGroups) {
            this.translatableItems.set(`${item.id}_${ItemType.GROUP}`, item.translations);
            this.translatableItems.set(`${item.id}_${ItemType.GROUP}_total`, item.totalTranslations);
        }

        const flattenFlis: TranslationResponse[] = [
            ...templateTranslations.balanceFlis,
            ...templateTranslations.incomeFlis,
        ];

        for (const item of flattenFlis) {
            this.translatableItems.set(`${item.id}_${ItemType.FLI}`, item.translations);
        }

        const flattenSubTotal: TranslationResponse[] = [
            ...templateTranslations.balanceSubtotals,
            ...templateTranslations.incomeSubtotals,
        ];

        for (const item of flattenSubTotal) {
            this.translatableItems.set(`${item.id}_${ItemType.SUB_TOTAL}`, item.translations);
        }

        const flattenSubfli: TranslationResponse[] = [
            ...templateTranslations.balanceSubflis,
            ...templateTranslations.incomeSubflis,
        ];

        for (const item of flattenSubfli) {
            this.translatableItems.set(`${item.id}_${ItemType.SUB_FLI}`, item.translations);
        }

        const flattenOfThatItem: TranslationResponse[] = [
            ...templateTranslations.balanceOfThatItems,
            ...templateTranslations.incomeOfThatItems,
        ];

        for (const item of flattenOfThatItem) {
            this.translatableItems.set(`${item.id}_${ItemType.OF_THAT_ITEM}`, item.translations);
        }
    }
    private setSettingsTranslationsItemsInMap(settingsTranslations: SettingsTranslationResponse): void {
        for (const item of settingsTranslations.currencies) {
            this.translatableItems.set(item.id, item.translations);
        }
    }

    override save(): Observable<void> {
        this.mixpanelService.track(MIXPANEL_EVENTS.FINISH_AND_PRINT_TIME_SPENT_TILL_COMPLETION);

        if (this.currentAnnualReport == null) {
            throw new Error('Current annual report is undefined');
        }
        if (this.activeAnnualReportEncryptedId == null) {
            throw new Error('activeAnnualReportEncryptedId is undefined; print options cannot be updated');
        }
        this.currentAnnualReport.printOptions = cloneDeep<IPrintOptions>({
            ...this.printOptionsDataToBeSaved,
            displayOptions: {
                ...this.printOptionsDataToBeSaved.displayOptions,
            },
        });
        this.isSaveRequestInProgress = true;
        // Sealing locks the financial content, so the whole-report PUT is rejected for a
        // sealed report. Persist ONLY printOptions via the scoped PATCH endpoint, which stays
        // available when sealed; the backend loads the report and applies just printOptions.
        this.providerOfAnnualReports.dispatchUpdatePrintOptions(
            this.activeAnnualReportEncryptedId,
            this.currentAnnualReport.printOptions,
        );
        // The PATCH does not touch the store; a later whole-report save (the translations) would
        // otherwise send the print options as they were when the page loaded.
        const printOptions = this.currentAnnualReport.printOptions;
        this.syncStoredReport((report) => ({ ...report, printOptions }));
        return of(void 0);
    }

    protected printAnnualReport(reorderedAnnualReportSections?: IReportSection[]): void {
        const annualReportVisitor = new AnnualReportVisitor(
            this.activeLocale,
            this.reportLocale,
            this.translatableItems,
            this.printOptionsDataToBeSaved.reportSectionsTitles,
            this.i18next,
        );

        this.predifinedLables = annualReportVisitor.predifinedLabels;

        const pdfContent = this.getPrintableContent(reorderedAnnualReportSections);
        this.printWindow = window.open();
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;
        this.providerOfAnnualReports.dispatchPrintAnnualReport(pdfContent);
    }

    protected getDefaultReportSections(): IReportSection[] {
        return ReportSectionsHelper.getReportSections(
            this.predifinedLables,
            this.printDisplayOptions,
            this.activeArNavigations,
            this.complementaryReportsTitles,
            this.currentAnnualReport,
            this.isFixedAssetsScheduleDataValid,
        );
    }

    public onPrintComplementaryReport(request: { index: number; fileId?: string }): void {
        if (
            this.printOptionsDataToBeSaved == null ||
            this.currentAnnualReport == null ||
            this.pdfTronMapper == null ||
            this.translatedAnnualReport == null
        ) {
            return;
        }

        const complementaryReports = this.translatedAnnualReport.complementaryReports ?? [];
        if (complementaryReports[request.index] == null) {
            return;
        }

        const printOptionsForStandalone = this.complementaryReportPrintService.buildStandalonePrintOptions(
            this.printOptionsDataToBeSaved,
            request,
        );
        const annualReportForStandalone = this.complementaryReportPrintService.cloneAnnualReportForStandalone(
            this.translatedAnnualReport,
            request,
        );

        const printWindow = window.open();
        if (!printWindow) {
            return;
        }
        this.printWindow = printWindow;
        this.printWindow.document.body.innerHTML = LOADING_SPINNER_STYLE;

        const printUsingPdfTronRequestData = this.getPdfTronDto(
            undefined,
            printOptionsForStandalone,
            annualReportForStandalone,
        );


        this.complementaryReportPrintService.applyStandaloneSectionToPrintData(
            this.pdfTronMapper,
            annualReportForStandalone,
            request,
            printUsingPdfTronRequestData,
        );

        this.providerOfAnnualReports.dispatchPrintAnnualReportUsingPdfTron(printUsingPdfTronRequestData);
    }


    protected showReorderReportDialog(): Observable<IReportOrderResult | undefined> {
        const sections = this.getDefaultReportSections();

        const reorderReportDialogInputData: IReorderingReportData = {
            reportSections: sections.flat(),
            showCoverPage: this.printDisplayOptions.showCoverSheet,
            showTOC: this.printDisplayOptions.showTableOfContents,
            printOrder: this.orderedSectionsIds,
        };
        const dialogRef = this.matDialog.open<
            ReorderReportSectionsDialogComponent,
            IReorderingReportData,
            IReportOrderResult | undefined
        >(ReorderReportSectionsDialogComponent, {
            width: '40%',
            data: reorderReportDialogInputData,
            panelClass: MAT_DIALOG_CUSTOM_CLASS,
        });

        return dialogRef.afterClosed().pipe(
            filter((reorderSectionList) => reorderSectionList != null),
            untilDestroyed(this),
        );
    }

    protected getPrintableContent(reportSections?: IReportSection[]): IAnnualReportPdfRequest {
        const util = new PrintingUtil({
            printPreviewPageClassNameSelector: PRINT_PREVIEW_CLASS_NAME_SELECTOR,
            printOptionsData: this.printOptionsDataToBeSaved,
            isShowAuthoringCompany: this.printOptionsDataToBeSaved?.displayOptions?.showCompanyInfos,
            authoringCompanyName: this.organization.name,
            companyName: this.companyName,
            companyLogoPdfBase64Getter: () => this.companyLogoPdfBase64Getter(),
            reportSections: reportSections == null ? this.getDefaultReportSections() : reportSections,
        });

        const content = util.getPrintableContent();
        return content;
    }

    protected override isDataNewlyCreatedAndSaveable(): boolean {
        if (this.currentAnnualReport && this.currentAnnualReport.printOptions == null) {
            return true;
        }
        return false;
    }

    protected override isDataChanged = (): Observable<boolean> => {

        if (this.isSaveRequestInProgress) {
            return this.savedSuccessfully.pipe(map((isSavedSuccessfully) => !isSavedSuccessfully));
        }

        if (this.printOptionsDataToBeSaved == null) {
            return of(false);
        }

        if (this.printOptionsDataToBeSaved != null && this.printOptionsDataToBeSaved.hasOwnProperty('reportSectionsTitles') &&
            this.printOptionsDataToBeSaved.reportSectionsTitles == null) {
            this.printOptionsDataToBeSaved = omit(this.printOptionsDataToBeSaved, 'reportSectionsTitles');
        }

        if (fastDeepEqual(this.printOptionsDataToBeSaved, this.defaultPrintOptionsValue)) {
            return of(false);
        }

        if (this.currentAnnualReport == null) {
            throw of(false);
        }

        // Compare if a first section title is changed
        if (
            this.printOptionsDataToBeSaved.hasOwnProperty('reportSectionsTitles') &&
            this.printOptionsDataToBeSaved.reportSectionsTitles !== null &&
            !this.currentAnnualReport.printOptions?.hasOwnProperty('reportSectionsTitles')
        ) {
            return of(true);
        }

        // Custom deep comparison function that ignores specific keys and null/undefined values
        const compareObjects = (obj1: any, obj2: any, path = ''): boolean => {
            // If either is not an object or is null, directly compare
            if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
                if (obj1 !== obj2) {
                    return false;
                }
                return true;
            }

            if (Array.isArray(obj1) || Array.isArray(obj2)) {
                if (!Array.isArray(obj1) || !Array.isArray(obj2)) {
                    return false;
                }
                if (obj1.length !== obj2.length) {
                    return false;
                }
                for (let index = 0; index < obj1.length; index += 1) {
                    if (!compareObjects(obj1[index], obj2[index], `${path}[${index}]`)) {
                        return false;
                    }
                }
                return true;
            }

            // Get all keys from both objects
            const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);

            // Keys to ignore
            if (path === '') allKeys.delete('reportOrder');

            // Compare all keys recursively
            for (const key of allKeys) {
                // Ignore keys where either value is null or undefined
                if (obj1[key] === undefined || obj2[key] === null || obj2[key] === undefined) {
                    continue; // Skip this key and continue to the next one
                }

                // Skip if key doesn't exist in either object
                if (!(key in obj1) || !(key in obj2)) {
                    return false;
                }

                // Recursively compare for nested objects
                if (!compareObjects(obj1[key], obj2[key], path ? `${path}.${key}` : key)) {
                    return false;
                }
            }

            return true;
        };

        // Compare the objects ignoring problematic keys and null/undefined values
        const isPrintOptionsSaved = compareObjects(
            this.currentAnnualReport.printOptions,
            this.printOptionsDataToBeSaved,
        );

        return of(!isPrintOptionsSaved);
    };

    protected exportExcel(): void {
        this.mixpanelService.track(MIXPANEL_EVENTS.EXPORT_TO_EXCEL_BUTTON_CLICK);

        const options: IOptions = {
            showAdjustmentInSums: false,
            showUID: false,
            showRatios: false,
            showCover: false,
            showTOC: false,
            showNotesInDetailInToc: false,
            showCompanyInfos: false,
            showShareholderInfo: this.printOptionsDataToBeSaved.displayOptions.showShareholderInformation,
            disableBalanceSheetPageBreak: false,
            displayAssetsAndLiabilitiesInSamePage: false,
            textColor: this.printOptionsDataToBeSaved.styleOptions.textColor,
            titleColor: this.printOptionsDataToBeSaved.styleOptions.titleColor,
            highlightColor: this.printOptionsDataToBeSaved.styleOptions.backgroundColor,
            backgroundColorPY: this.printOptionsDataToBeSaved.styleOptions.backgroundColorPY,
            tableHeaderColor: this.printOptionsDataToBeSaved.styleOptions.tableHeaderColor,
            tableFooterColor: this.printOptionsDataToBeSaved.styleOptions.tableFooterColor,
            showReportCompanyLogo: this.printOptionsDataToBeSaved.displayOptions.showCompanyLogo,
            internalLabel: 'Intern',
            showRoundingDisclaimer: false,
            showAccounts: this.printOptionsDataToBeSaved.displayOptions.showAccounts,
            repeatAppendixTitle: this.printOptionsDataToBeSaved.displayOptions.repeatAppendixTitle,
            isSealed: this.currentAnnualReport.isSealed ?? false,
            showPageNumbers: true,
        };

        const complementaryReportsAsAppendix = this.currentAnnualReport.complementaryReports?.filter(
            (report) => report.printLocation === PrintLocation.APPENDIX,
        );

        // REV-20899: clone+force the flag on so excel export includes reclasses.
        const printOptionsWithReclasses = this.forceReclassInSumsOn(cloneDeep<IPrintOptions>(this.printOptionsDataToBeSaved));
        const pdfTronSections = this.pdfTronMapper.getSections(
            this.translatedAnnualReport,
            printOptionsWithReclasses,
            this.annualReportForAutofill,
            printOptionsWithReclasses.reportOrder,
            options,
            this.predifinedLables,
            this.userLocale,
            this.activeLocale,
            this.reportLocale,
            complementaryReportsAsAppendix,
            this.currentFinStatements,
        );

        const excelDataToExport = this.excelMapper.mapPdfTronSectionsDataToExcelData(pdfTronSections);
        this.providerOfAnnualReports.dispatchExportAnnualReportExcel(excelDataToExport);
    }

    protected exportExcelStructured(): void {
        //IN HERE WE HAVE TO IMPLEMENT A LOGIC TO EXPORT THE DATA TO EXCEL WHICH IS SIMILAIR TO THE PDF TRON
        let notesComponentsHTMLMap: Map<string, Map<string, string>> | undefined;
        if (
            this.printOptionsDataToBeSaved.displayOptions.showNotes &&
            (this.translatedAnnualReport?.notes?.accordions?.length ?? 0) !== EMPTY_ARRAY_LENGTH
        ) {
            const notesComponentsHTMLUtil = new NotesComponentsHTMLUtil(
                this.translatedAnnualReport?.notes?.accordions || [],
                this.printDisplayOptions,
                this.notesEmptyLinesRemovalHelper,
            );

            notesComponentsHTMLMap = notesComponentsHTMLUtil.getNotesComponentsHTMLMap(this.activeLocale);
        }

        const excelDataToExport = this.getPdfTronDto(notesComponentsHTMLMap);
        this.stripAopHtmlForExcel(excelDataToExport);

        // Include extra Excel content (DATEV Sammelkonten/Kontokorrent) if available
        const excelDataToExportWithExtra = this.currentAnnualReport?.extraExcelContent
            ? { ...excelDataToExport, extraExcelData: this.currentAnnualReport.extraExcelContent }
            : excelDataToExport;

        let notesCopy = [...(this.translatedAnnualReport?.notes?.accordions || [])];
        if (this.printOptionsDataToBeSaved.displayOptions.hideEmptyLines) {
            notesCopy = this.notesEmptyLinesRemovalHelper.removeEmptyLinesOfNotes(notesCopy, this.activeLocale);
        }

        const numberedNotes = this.notesNumberingHelper.applyNumbering(
            notesCopy,
            this.activeLocale,
            false,
            this.defaultLanguage,
        );
        const numberedTitles = this.notesNumberingHelper.createNumberingObject(numberedNotes, this.activeLocale);

        const finalData = this.excelMapper.prepareNotesDataForExcelStructuredExport(
            notesCopy,
            excelDataToExportWithExtra.data,
            this.activeLocale,
            this.currentAnnualReport?.generalInformation?.balanceSheetDate,
            this.currentAnnualReport?.generalInformation?.balancePreviousYearDate,
            numberedTitles,
            this.placeholderMap,
            this.buildFxForExcelExport(),
            this.currentAnnualReport,
        );

        excelDataToExportWithExtra.data = finalData;

        this.providerOfAnnualReports.dispatchExportAnnualReportExcelStructured(excelDataToExportWithExtra);
    }

    private stripAopHtmlForExcel(dto: PrintUsingPdfTronDto): void {
        const aop = dto?.data?.aop;
        if (aop == null) {
            return;
        }
        if (aop.description) {
            aop.description = this.htmlToPlainText(aop.description);
        }
        if (aop.ccrFootnote) {
            aop.ccrFootnote = this.htmlToPlainText(aop.ccrFootnote);
        }
    }

    private htmlToPlainText(html: string): string {
        // Same approach as the notes RICH_TEXT path in excel.mapper.ts.
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    }

    protected onSaveSuccessfully() {
        // TODO: only the printOptions should be cloned not the entire annual report
        this.originalAnnualReport = cloneDeep<IAnnualReport | undefined>(this.currentAnnualReport);
        this.printOptionsData = cloneDeep<IPrintOptions>(this.printOptionsDataToBeSaved);
        this.isSaveRequestInProgress = false;
        this.savedSuccessfully.next(true);
        this.fireSuccessNotification();

        if (this.sealAfterSave) {
            this.annualReportProvider.dispatchSealAnnualReport(this.activeAnnualReportEncryptedId);
        }
    }

    protected onSaveFailed(): void {
        this.isSaveRequestInProgress = false;
        this.sealAfterSave = false;
        this.savedSuccessfully.next(false);
        this.fireErrorMessage();
    }

    protected handleErrors(error: HttpErrorResponse): void {
        debug(error, 'notes tab error');

        if (error == null) {
            this.isBackendReturnError = false;
        }

        if (error != null && error.status !== 404) {
            this.isBackendReturnError = true;
            this.backendErrors = Errors.ServerError;
        }
    }

    companyLogoPdfBase64Getter = () => {
        if (this.printDisplayOptions.showCompanyLogo) {
            return this.logoPDFFileBase64;
        }
        return null;
    };

    protected onShareClick(emails: string[], emailMessage: string): void {
        this.invitationDialogRef.close();
        this.shareHandler(emails, emailMessage);
    }

    protected onConsistencyInputDataUpdate(): void {
        if (this.currentAnnualReport == null) {
            return;
        }
        if (this.currentAnnualReport.cashFlowStatement == null) {
            this.calculateEqualityCheckData(this.currentAnnualReport, this.currentFinStatements);
        } else {
            this.currentCashflowStatementTotal =
                CashFlowStatementPrintPreviewHelper.calculateAllActivitiesCurrentYearTotals(
                    this.currentAnnualReport.cashFlowStatement,
                    2,
                );
            if (!this.noPreviousData) {
                this.previousCashflowStatementTotal =
                    CashFlowStatementPrintPreviewHelper.calculateAllActivitiesPreviousYearTotals(
                        this.currentAnnualReport.cashFlowStatement,
                        2,
                    );
            }
            this.calculateEqualityCheckData(this.currentAnnualReport, this.currentFinStatements);
        }
    }

    protected calculateEqualityCheckData(annualReport: IAnnualReport, finStatements: IFinStatements[]): void {
        let assetsAndLiabilitiesEqualityCheckResult: EqualityChecksResult;
        let profitIncomeAndProfitFliEqualityCheckResult: EqualityChecksResult;
        let cashFlowStatementTotalsEqualityCheckResult: EqualityChecksResult | undefined;
        let totalReclassesAssetsAndTotalReclassesLiabilitiesEqualityCheckResult: EqualityChecksResult | undefined;
        let totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult: EqualityChecksResult | undefined;
        let totalReclassesIncomeAndTotalReclassesProfitFliEqualityCheckResult: EqualityChecksResult | undefined;
        let totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult: EqualityChecksResult | undefined;

        if (finStatements != null && finStatements.length >= templateConstants.financialStatementMinimumLength) {
            const balanceTemplate =
                finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template;
            const incomeTemplate =
                finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template;

            if (
                EqualityChecksHelper.findProfitFliInBalance(balanceTemplate) == null && !this.profitFliErrorMessageShown
            ) {
                this.profitFliErrorMessageShown = true;
                this.fireErrorMessage('aumico_reports_error_profit_fli_not_found');
            }

            assetsAndLiabilitiesEqualityCheckResult = EqualityChecksHelper.checkAssetsEqualLiabilities(
                balanceTemplate,
            );

            profitIncomeAndProfitFliEqualityCheckResult = EqualityChecksHelper.checkProfitIncomeEqualProfitFLI(
                balanceTemplate,
                incomeTemplate,
            );
        } else {
            assetsAndLiabilitiesEqualityCheckResult = EqualityChecksResult.BOTH_NOT_EQUAL;
            profitIncomeAndProfitFliEqualityCheckResult = EqualityChecksResult.BOTH_NOT_EQUAL;
        }

        this.equalityCheckDataCurrentYear.isMappingAssetsAndLiabilitiesConsistent =
            assetsAndLiabilitiesEqualityCheckResult !== EqualityChecksResult.CLOSING_NOT_EQUAL &&
            assetsAndLiabilitiesEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;

        this.equalityCheckDataCurrentYear.isMappingProfitIncomeAndProfitFliConsistent =
            profitIncomeAndProfitFliEqualityCheckResult !== EqualityChecksResult.CLOSING_NOT_EQUAL &&
            profitIncomeAndProfitFliEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;

        if (!this.noPreviousData) {
            this.equalityCheckDataPreviousYear.isMappingAssetsAndLiabilitiesConsistent =
                assetsAndLiabilitiesEqualityCheckResult !== EqualityChecksResult.OPENING_NOT_EQUAL &&
                assetsAndLiabilitiesEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;

            this.equalityCheckDataPreviousYear.isMappingProfitIncomeAndProfitFliConsistent =
                profitIncomeAndProfitFliEqualityCheckResult !== EqualityChecksResult.OPENING_NOT_EQUAL &&
                profitIncomeAndProfitFliEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;
        }

        if (this.activeArNavigations.includes(AnnualReportStep.ADJUSTMENTS_RECLASSIFICATION)) {
            totalReclassesAssetsAndTotalReclassesLiabilitiesEqualityCheckResult =
                EqualityChecksHelper.checkTotalReclassesAssetsEqualTotalReclassesLiabilities(
                    finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template,
                );

            totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult =
                EqualityChecksHelper.checkTotalAdjustmentsAssetsEqualTotalAdjustmentsLiabilities(
                    finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template,
                );

            try {
                totalReclassesIncomeAndTotalReclassesProfitFliEqualityCheckResult =
                    EqualityChecksHelper.checkTotalReclassesIncomeEqualTotalReclassesProfitFLI(
                        finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template,
                        finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template,
                    );
            } catch (error) {
                console.error('Error in checkTotalReclassesIncomeEqualTotalReclassesProfitFLI:', error);
                totalReclassesIncomeAndTotalReclassesProfitFliEqualityCheckResult = EqualityChecksResult.BOTH_NOT_EQUAL;
            }

            try {
                totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult =
                    EqualityChecksHelper.checkTotalAdjustmentsIncomeEqualTotalAdjustmentsProfitFLI(
                        finStatements[templateConstants.balanceTemplate].templateAndAccountsMapping.template,
                        finStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template,
                    );
            } catch (error) {
                console.error('Error in checkTotalAdjustmentsIncomeEqualTotalAdjustmentsProfitFLI:', error);
                totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult =
                    EqualityChecksResult.BOTH_NOT_EQUAL;
            }

            // REV-20899: isReclassesAssetsAndLiabilitiesConsistent / isReclassesProfitIncomeAndProfitFliConsistent
            // removed — reclassifications are always balanced by construction (transactional double-entry).

            this.equalityCheckDataCurrentYear.isAdjustmentsAssetsAndLiabilitiesConsistent =
                totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult !==
                EqualityChecksResult.CLOSING_NOT_EQUAL &&
                totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult !==
                EqualityChecksResult.BOTH_NOT_EQUAL;

            this.equalityCheckDataCurrentYear.isAdjustmentsProfitIncomeAndProfitFliConsistent =
                totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult !==
                EqualityChecksResult.CLOSING_NOT_EQUAL &&
                totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult !==
                EqualityChecksResult.BOTH_NOT_EQUAL;

            if (!this.noPreviousData) {
                this.equalityCheckDataPreviousYear.isAdjustmentsAssetsAndLiabilitiesConsistent =
                    totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult !==
                    EqualityChecksResult.OPENING_NOT_EQUAL &&
                    totalAdjustmentsAssetsAndTotalAdjustmentsLiabilitiesEqualityCheckResult !==
                    EqualityChecksResult.BOTH_NOT_EQUAL;

                this.equalityCheckDataPreviousYear.isAdjustmentsProfitIncomeAndProfitFliConsistent =
                    totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult !==
                    EqualityChecksResult.OPENING_NOT_EQUAL &&
                    totalAdjustmentsIncomeAndTotalAdjustmentsProfitFliEqualityCheckResult !==
                    EqualityChecksResult.BOTH_NOT_EQUAL;
            }
        }

        if (
            this.activeArNavigations.includes(AnnualReportStep.CFS) &&
            annualReport.cashFlowStatement != null &&
            this.currentCashflowStatementTotal != null &&
            this.previousCashflowStatementTotal != null
        ) {
            cashFlowStatementTotalsEqualityCheckResult = EqualityChecksHelper.checkCashFlowStatementTotalsAreEqual(
                annualReport.cashFlowStatement,
                this.currentCashflowStatementTotal,
                this.previousCashflowStatementTotal,
            );

            this.equalityCheckDataCurrentYear.isCashflowStatementTotalsConsistent =
                cashFlowStatementTotalsEqualityCheckResult !== EqualityChecksResult.CLOSING_NOT_EQUAL &&
                cashFlowStatementTotalsEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;

            if (!this.noPreviousData) {
                this.equalityCheckDataPreviousYear.isCashflowStatementTotalsConsistent =
                    cashFlowStatementTotalsEqualityCheckResult !== EqualityChecksResult.OPENING_NOT_EQUAL &&
                    cashFlowStatementTotalsEqualityCheckResult !== EqualityChecksResult.BOTH_NOT_EQUAL;
            }
        }
    }

    protected prepareIncomeItemsOptionsForCalculatingRatio(): void {
        if (this.currentAnnualReport == null) {
            return;
        }
        const isFinStatementsLessThanMinLength =
            this.currentFinStatements.length < templateConstants.financialStatementMinimumLength;
        const isIncomeTemplateEqualNull =
            !isFinStatementsLessThanMinLength &&
            this.currentFinStatements[templateConstants.incomeTemplate].templateAndAccountsMapping.template == null;
        if (isFinStatementsLessThanMinLength || isIncomeTemplateEqualNull) {
            return;
        }
        const incomeMappingTemplateGroup = (
            this.currentFinStatements[templateConstants.incomeTemplate].templateAndAccountsMapping
                .template as IAccountMappingTemplate
        ).group;
        // prepare ratio drop down options for income statement
        this.incomeItemsOptionsForCalculatingRatio = this.printPageHelper.getIncomeItemsOptionsForCalculatingRatio(
            incomeMappingTemplateGroup,
            this.printDisplayOptions.showAdjustmentInSums,
            this.printDisplayOptions.showReClassInSums,
            this.noPreviousData ?? false,
        );
    }

    protected addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    protected setArNavigation(navigations: AnnualReportStep[]): void {
        this.activeArNavigations = cloneDeep<AnnualReportStep[]>(navigations);
    }

    protected hasCompletedShareInformationData(annualReportMetaInformation: AnnualReportMetaInformationDTO): boolean {
        return (
            annualReportMetaInformation.shareInformation &&
            annualReportMetaInformation.shareInformation.sharedBy != undefined
        );
    }

    protected handlePrintOnlyText() {
        this.nextStepPrefix = null;
        this.printStepLabel = Constants.ACTION_BAR.LABELS.PRINT_STEP_LABEL;
    }

    private setReportLocaleIfNotExist(locales: string[], reportLocaleIndex: number): string[] {
        const localesWithReportLocale = [...locales];
        if (reportLocaleIndex < 0) {
            localesWithReportLocale.unshift(this.reportLocale);
        } else {
            localesWithReportLocale.splice(reportLocaleIndex, 1);
            localesWithReportLocale.unshift(this.reportLocale);
        }
        return localesWithReportLocale;
    }

    public onAopSnapshotChanged(): void {
        // Fired only when a re-captured AOP snapshot actually changed (the child dedupes), AFTER
        // the print view was regenerated with the new options. Rebuild the print view so the
        // complementary reports embed the up-to-date @aop.snapshot instead of the previous one.
        if (this.pdfTronMapper != null && this.printOptionsDataToBeSaved != null) {
            this.handlePrintPreview();
        }
    }

    public onAopSnapshotCurrentYearChanged(): void {
        // The current-year snapshot is coalesced into the single aopSnapshotChanged emission
        // (see refreshAopSnapshots in the print-preview pages), so no separate rebuild is needed.
    }

    onCompanyLogoEmitted(logo: string): void {
        this.logoCompanyBase64 = logo;
    }

    onShowSealHistory() {
        this.annualReportProvider.dispatchGetReportSealHistory(this.annualReportEncryptedId);
        this.showSealHistory = true;
    }

    onSealReport() {
        this.showSealReportDialog = false;

        // Save the report before sealing to ensure the user seals what they see
        this.isDataChanged().pipe(
            untilDestroyed(this),
        ).subscribe((hasChanges) => {
            if (hasChanges || this.isDataNewlyCreatedAndSaveable()) {
                this.sealAfterSave = true;
                this.save();
            } else {
                this.annualReportProvider.dispatchSealAnnualReport(this.activeAnnualReportEncryptedId);
            }
        });
    }

    onUnSealReport() {
        this.unsealInProgress = true;
        this.annualReportProvider.dispatchUnsealAnnualReport(this.activeAnnualReportEncryptedId);
        this.showUnsealReportDialog = false;
    }

    onShowUnsealReport() {
        this.showUnsealReportDialog = true;
    }

    private setAnnualReportStep(): void {
        if (this.currentAnnualReport && this.currentAnnualReport.annualReportTemplate != null) {
            this.annualReportTemplateSettings = cloneDeep<IAnnualReportTemplateSettings>(
                this.currentAnnualReport.annualReportTemplate.settings,
            );
        }
        this.setArNavigation(AnnualReportStepsHelper.getTemplateStepsOrDefault(this.currentAnnualReport));
    }
}

